(function () {
/* eslint-disable max-len, no-param-reassign, no-unused-vars */ /**
 * Air theme JavaScript.
 */ // Import modules
/* eslint-disable no-param-reassign */ function $72f32b121603cc1b$export$2e2bcd8739ae039(stringKey) {
    if (typeof window.air_light_screenReaderText === 'undefined' || typeof window.air_light_screenReaderText[stringKey] === 'undefined') {
        // eslint-disable-next-line no-console
        console.error(`Missing translation for ${stringKey}`);
        return '';
    }
    return window.air_light_screenReaderText[stringKey];
}


function $be72fc40c39eb295$var$isLinkExternal(link, localDomains) {
    // Empty links are not external
    if (!link.length) return false;
    const exceptions = [
        '#',
        'tel:',
        'mailto:',
        '/'
    ];
    // Check if the url starts with some of the exceptions
    const isException = exceptions.some((exception)=>{
        const compare = new RegExp(`^${exception}`, 'g');
        return compare.test(link);
    });
    if (isException) return false;
    let linkUrl;
    try {
        linkUrl = new URL(link);
    } catch (error) {
        // eslint-disable-next-line no-console
        console.log(`Invalid URL: ${link}`);
        return false;
    }
    // Check if host is one of the local domains
    return !localDomains.some((domain)=>linkUrl.host === domain);
}
function $be72fc40c39eb295$export$967d794570dbbeff(link) {
    const children = [
        ...link.children
    ];
    if (children.length === 0) return '';
    const childImgs = children.filter((child)=>child.tagName.toLowerCase() === 'img');
    // If there are other elements than img elements, no need to add aria-label
    if (children.length !== childImgs.length) return '';
    // Find alt texts and add to array
    const altTexts = childImgs.filter((child)=>child.alt && child.alt !== '').map((child)=>child.alt);
    // If there is no alt texts,
    if (!altTexts.length) return '';
    return altTexts.join(', ');
}
function $be72fc40c39eb295$export$554fdaa2aa89d7a4() {
    let localDomains = [
        window.location.host
    ];
    if (typeof window.air_light_externalLinkDomains !== 'undefined') localDomains = localDomains.concat(window.air_light_externalLinkDomains);
    const links = document.querySelectorAll('a');
    const externalLinks = [
        ...links
    ].filter((link)=>$be72fc40c39eb295$var$isLinkExternal(link.href, localDomains));
    // eslint-disable-next-line consistent-return
    externalLinks.forEach((externalLink)=>{
        // Abort mission if there is only img element inside of link
        if (externalLink.childElementCount === 1 && externalLink.children[0].tagName.toLowerCase() === 'img') return false;
        if (!externalLink.classList.contains('no-external-link-label')) {
            const textContent = externalLink.textContent.trim().length ? externalLink.textContent.trim() : $be72fc40c39eb295$export$967d794570dbbeff(externalLink);
            if (textContent && !externalLink.getAttribute('aria-label')) {
                const ariaLabel = externalLink.target === '_blank' ? `${textContent}: ${(0, $72f32b121603cc1b$export$2e2bcd8739ae039)('external_link')}, ${(0, $72f32b121603cc1b$export$2e2bcd8739ae039)('target_blank')}` : `${textContent}: ${(0, $72f32b121603cc1b$export$2e2bcd8739ae039)('external_link')}`;
                externalLink.setAttribute('aria-label', ariaLabel);
            }
        }
        // Arrow icon won't be added if one of these classes is defined for the link
        const classExceptions = [
            'no-external-link-indicator',
            'global-link',
            'button'
        ];
        if (!classExceptions.some((className)=>externalLink.classList.contains(className))) {
            // Add SVG arrow icon
            externalLink.insertAdjacentHTML('beforeend', '<svg class="external-link-icon" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 9 9"><path d="M4.499 1.497h4v4m0-4l-7 7" fill="none" fill-rule="evenodd" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"></path></svg>');
            externalLink.classList.add('is-external-link');
        }
    });
}
function $be72fc40c39eb295$export$636763119f974537() {
    // Add aria-labels to links without text or aria-labels and contain image with alt text
    const links = [
        ...document.querySelectorAll('a')
    ];
    // eslint-disable-next-line no-unused-vars
    const linksWithImgChildren = links.forEach((link)=>{
        // If link already has text content or an aria label no need to add aria-label
        if (link.textContent.trim() !== '' || link.ariaLabel) return;
        const ariaLabel = $be72fc40c39eb295$export$967d794570dbbeff(link);
        if (ariaLabel !== '') link.ariaLabel = ariaLabel;
    });
}


/* eslint-disable no-param-reassign, no-undef */ const $b4666473b658c810$var$initAnchors = ()=>{
    let triggers = document.querySelectorAll('a[href*="#"]:not([href="#"]):not(#top)');
    triggers = Array.from(triggers);
    triggers.forEach((trigger)=>{
        const targetId = trigger.hash.substring(1);
        const target = document.getElementById(targetId);
        trigger.addEventListener('click', (event)=>{
            event.preventDefault(); // Prevent default behavior of anchor links
            // If the trigger is nav-link, close nav
            if (trigger.classList.contains('nav-link') || trigger.classList.contains('dropdown-item')) {
                document.body.classList.remove('js-nav-active');
                // Additional navigation cleanup
                const html = document.documentElement;
                const container = document.getElementById('main-navigation-wrapper');
                const menu = container?.querySelector('ul');
                const button = document.getElementById('nav-toggle');
                if (html) html.classList.remove('disable-scroll');
                if (container) container.classList.remove('is-active');
                if (button) {
                    button.classList.remove('is-active');
                    button.setAttribute('aria-expanded', 'false');
                }
                if (menu) menu.setAttribute('aria-expanded', 'false');
            }
            // Check if the target element exists on the current page
            if (target) {
                // Scroll to the target element
                target.scrollIntoView({
                    behavior: 'smooth',
                    block: 'start'
                });
                // Update URL history
                window.history.pushState('', '', trigger.hash);
                // Focus on the target element
                target.setAttribute('tabindex', '-1');
                target.focus({
                    preventScroll: true
                });
            } else // Navigate to the target page
            window.location.href = trigger.href;
        });
    });
};
var $b4666473b658c810$export$2e2bcd8739ae039 = $b4666473b658c810$var$initAnchors;


/* eslint-disable max-len */ const $8bc14fcfe2c466c1$var$backToTop = ()=>{
    const topButton = document.getElementById('top');
    const focusableElements = document.querySelectorAll('button, a, input, select, textarea, [tabindex]:not([tabindex="-1"])');
    function trackScroll() {
        const scrolled = window.pageYOffset;
        const scrollAmount = document.documentElement.clientHeight;
        if (scrolled > scrollAmount) topButton.classList.add('is-visible');
        if (scrolled < scrollAmount) topButton.classList.remove('is-visible');
    }
    function scroll(focusVisible) {
        // Check if user prefers reduced motion, if so, just scroll to top
        const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        if (prefersReducedMotion) {
            focusableElements[0].focus({
                focusVisible: focusVisible
            });
            return;
        }
        // Move smoothly to the first focusable element on the page
        focusableElements[0].scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
        // Focus too, if on keyboard
        focusableElements[0].focus({
            preventScroll: true,
            focusVisible: focusVisible
        });
    }
    if (topButton) {
        topButton.addEventListener('click', (event)=>{
            // Don't add hash in the end of the url
            event.preventDefault();
            // Focus without visibility (as user is not using keyboard)
            scroll(false);
        });
        topButton.addEventListener('keydown', (event)=>{
            // Don't propagate keydown event to click event
            event.preventDefault();
            // Scroll with focus visible
            scroll(true);
        });
    }
    window.addEventListener('scroll', trackScroll);
};
var $8bc14fcfe2c466c1$export$2e2bcd8739ae039 = $8bc14fcfe2c466c1$var$backToTop;


const $244ddd85eab3a286$var$initA11ySkipLink = ()=>{
    // Go through all the headings of the page and select the first one
    const a11ySkipLinkTarget = document.querySelectorAll('h1, h2, h3, h4, h5, h6')[0];
    const a11ySkipLink = document.querySelectorAll('.skip-link')[0];
    // When clicked, move focus to the target element
    if (a11ySkipLink) a11ySkipLink.addEventListener('click', ()=>{
        a11ySkipLinkTarget.setAttribute('tabindex', '-1');
        a11ySkipLinkTarget.focus();
        a11ySkipLinkTarget.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
        });
    });
};
var $244ddd85eab3a286$export$2e2bcd8739ae039 = $244ddd85eab3a286$var$initA11ySkipLink;


const $4e71423afcfa2c83$var$initA11yFocusSearchField = ()=>{
    const urlSearch = window.location.search;
    const urlParams = new URLSearchParams(urlSearch);
    if (urlParams.has('s')) {
        const searchField = document.querySelector('main input[name="s"]');
        if (searchField) searchField.focus({
            preventScroll: true
        });
    }
};
var $4e71423afcfa2c83$export$2e2bcd8739ae039 = $4e71423afcfa2c83$var$initA11yFocusSearchField;


/**
 * Navigation.js module
 * The original, accessible navigation module for Air-light
 */ // Import functions needed for the navigation module
// Event listener helper function
function $ce5c042a53fc3c5f$var$addMultipleEventListeners(element, events, handler) {
    events.forEach((e)=>element.addEventListener(e, handler));
}
var $ce5c042a53fc3c5f$export$2e2bcd8739ae039 = $ce5c042a53fc3c5f$var$addMultipleEventListeners;


function $bd070018dfff8e4c$var$a11yFocusTrap(e) {
    // Init focusable elements
    let focusableElements = [];
    // Define container
    const container = document.getElementById('nav');
    // Define nav-toggle
    const navToggle = document.getElementById('nav-toggle');
    // Get --breakpoint-nav from CSS
    const breakpointNav = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-nav');
    // Let's see if we are on mobile viewport
    const isMobile = window.matchMedia(`(max-width: ${breakpointNav})`).matches;
    // If things are not okay, bail
    if (!container || !navToggle || !isMobile) return;
    // Set focusable elements inside main navigation.
    focusableElements = [
        ...container.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')
    ].filter((el)=>!el.hasAttribute('disabled')).filter((el)=>!!(el.offsetWidth || el.offsetHeight || el.getClientRects().length));
    // Get first and last focusable element
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement = focusableElements[focusableElements.length - 1];
    // On key down on first element, if it's a Shift+Tab, redirect to last element
    if (firstFocusableElement === e.target && e.code === 'Tab' && e.shiftKey) {
        e.preventDefault();
        lastFocusableElement.focus();
    }
    // On key down on last element, if it's a Tab, redirect to first element
    if (lastFocusableElement === e.target && e.code === 'Tab' && !e.shiftKey) {
        e.preventDefault();
        firstFocusableElement.focus();
    }
}
var $bd070018dfff8e4c$export$2e2bcd8739ae039 = $bd070018dfff8e4c$var$a11yFocusTrap;


// Calculate mobile nav-toggle height
function $ebdaf21019182232$var$calculateDropdownToggleHeight() {
    // If .dropdown-toggle not found, bail
    if (!document.querySelectorAll('.dropdown-toggle')) {
        // eslint-disable-next-line no-console
        console.log('Warning: No dropdown-toggles found.');
        return;
    }
    // Find all .dropdown-toggle elements on mobile
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    // Loop through dropdown toggles
    dropdownToggles.forEach((dropdownToggle)=>{
        // Get the height of previous element
        const previousElement = dropdownToggle.previousElementSibling;
        if (previousElement) {
            const previousElementHeight = previousElement.offsetHeight;
            // Set the height of the dropdown toggle
            // eslint-disable-next-line no-param-reassign
            dropdownToggle.style.height = `${previousElementHeight}px`;
        }
    });
}
var $ebdaf21019182232$export$2e2bcd8739ae039 = $ebdaf21019182232$var$calculateDropdownToggleHeight;


// Import required modules
// Check if an element is out of the viewport
// eslint-disable-next-line func-names
const $9bbd30bb471b1292$var$isOutOfViewport = function(elem) {
    // Get element's bounding
    const bounding = elem.getBoundingClientRect();
    // Check if it's out of the viewport on each side
    const out = {};
    out.top = bounding.top < 0;
    out.left = bounding.left < 0;
    out.bottom = bounding.bottom >= (document.documentElement.clientHeight || document.body.clientHeight);
    out.right = bounding.right >= (document.documentElement.clientWidth || document.body.clientWidth);
    out.any = out.top || out.left || out.bottom || out.right;
    return out;
};
var $9bbd30bb471b1292$export$2e2bcd8739ae039 = $9bbd30bb471b1292$var$isOutOfViewport;


// Check for submenu overflow
function $53d3c8651e14ecb5$var$checkForSubmenuOverflow(items) {
    // If items not found, bail
    if (!items) {
        // eslint-disable-next-line no-console
        console.log('Warning: No items for sub-menus found.');
        return;
    }
    items.forEach((li)=>{
        // Find sub menus
        const subMenusUnderMenuItem = li.querySelectorAll('.sub-menu');
        // Loop through sub menus
        subMenusUnderMenuItem.forEach((subMenu)=>{
            // First let's check if submenu exists
            if (typeof subMenusUnderMenuItem !== 'undefined') {
                // Check if the sub menu is out of viewport or not
                const isOut = (0, $9bbd30bb471b1292$export$2e2bcd8739ae039)(subMenu);
                // At least one side of the element is out of viewport
                if (isOut.right) subMenu.classList.add('is-out-of-viewport');
            }
        });
    });
}
var $53d3c8651e14ecb5$export$2e2bcd8739ae039 = $53d3c8651e14ecb5$var$checkForSubmenuOverflow;


// Dropdown menu function
function $08609567837f9fc3$var$dropdownMenuOnHover(items) {
    // Optional timeout
    const hoverIntentTimeout = 0;
    items.forEach((li)=>{
        // eslint-disable-next-line func-names
        li.addEventListener('mouseover', function() {
            // Get --breakpoint-nav from CSS
            const breakpointNav = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-nav');
            // Let's see if we are on mobile viewport
            const isMobile = window.matchMedia(`(max-width: ${breakpointNav})`).matches;
            // If rules don't apply, bail
            if (li.classList.contains('removing-hover') || isMobile) return;
            // Add hover classes
            this.classList.add('hover-intent');
            this.classList.add('hovering');
            this.parentNode.classList.add('hover-intent');
            this.parentNode.classList.add('hovering');
            // Remove hovering class after a while
            setTimeout(()=>{
                this.classList.remove('hovering');
                this.parentNode.classList.remove('hovering');
            }, 500);
            document.addEventListener('keydown', (keydownMouseoverEvent)=>{
                // If rules don't apply, bail
                if (this.classList.contains('removing-hover') || !this.classList.contains('hovering') || !this.parentNode.classList.contains('hovering')) return;
                // Close navigation on Escape while hovering the navigation
                if (keydownMouseoverEvent.key === 'Escape') {
                    li.classList.remove('hover-intent');
                    li.parentNode.classList.remove('hover-intent');
                    li.parentNode.parentNode.classList.remove('hover-intent');
                    // Add class removing-hover to prevent the menu from opening again when moving the mouse
                    li.classList.add('removing-hover');
                    li.parentNode.classList.add('removing-hover');
                    // Remove removing-hover class after a while to re-initialize the menu
                    setTimeout(()=>{
                        this.classList.remove('removing-hover');
                        this.parentNode.classList.remove('removing-hover');
                    }, 500);
                }
            });
            // Remove removing-hover class after a while to re-initialize the menu
            setTimeout(()=>{
                this.classList.remove('removing-hover');
                this.parentNode.classList.remove('removing-hover');
            }, 500);
        });
        // eslint-disable-next-line func-names
        li.addEventListener('mouseleave', function() {
            setTimeout(()=>{
                // Remove hover-intent class on mouse leave
                this.classList.remove('hover-intent');
                this.parentNode.classList.remove('hover-intent');
                const dropdownToggles = this.querySelectorAll('.dropdown-toggle');
                dropdownToggles.forEach((dropdownToggle)=>{
                    // Set aria-expanded to false for all dropdown-toggle elements
                    dropdownToggle.setAttribute('aria-expanded', 'false');
                    if (dropdownToggle.parentNode.querySelector('.dropdown')) {
                        const linkText = dropdownToggle.parentNode.querySelector('.dropdown').textContent;
                        // Set aria-label to expand for all dropdown-toggle elements
                        // eslint-disable-next-line camelcase, no-undef
                        dropdownToggle.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkText}`);
                    }
                });
            }, hoverIntentTimeout);
            setTimeout(()=>{
                // Remove removing-hover class after a while to re-initialize the menu
                this.classList.remove('removing-hover');
                this.parentNode.classList.remove('removing-hover');
            }, 500);
        });
    });
}
var $08609567837f9fc3$export$2e2bcd8739ae039 = $08609567837f9fc3$var$dropdownMenuOnHover;


// Add proper link labels for screen readers
function $968b082be717d119$var$a11yAddDropdownToggleLabels(items) {
    items.forEach((li)=>{
        // If .dropdown-class does not exist then do nothing
        if (!li.querySelector('.dropdown')) return;
        // Get the dropdown-button
        const dropdownButton = li.querySelector('.dropdown-toggle');
        // Get the link text that is children of this item
        const linkText = li.querySelector('.dropdown').innerText;
        // Add the aria-label to the dropdown button
        // eslint-disable-next-line camelcase, no-undef
        dropdownButton.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkText}`);
    });
}
var $968b082be717d119$export$2e2bcd8739ae039 = $968b082be717d119$var$a11yAddDropdownToggleLabels;


// Import required modules

// Accessible keyboard navigation for dropdown menus
function $0ae90c2232c0c773$var$a11yDropdownMenuKeyboardNavigation(items, focusableElements) {
    focusableElements.forEach((item)=>{
        item.addEventListener('keyup', (e)=>{
            // Get this item
            const thisElement = e.target;
            // Close previous dropdown if this parent contains id main-menu
            if (thisElement.parentNode.parentNode.id === 'main-menu' || thisElement.classList.contains('button-nav') && thisElement.parentNode.parentNode.id === 'main-menu') // If we have previous item
            {
                if (thisElement.parentNode.previousElementSibling) {
                    // Get the previous item
                    const previousItem = thisElement.parentNode.previousElementSibling;
                    // Remove toggled-on class from previous item
                    previousItem.classList.remove('toggled-on');
                    // Remove hover-intent class from previous item
                    previousItem.classList.remove('hover-intent');
                    // If sub-menu found
                    if (previousItem.querySelector('.sub-menu')) {
                        // Get the previous item's dropdown
                        const previousItemDropdown = previousItem.querySelector('.sub-menu');
                        // Remove toggled-on class from previous sibling
                        previousItemDropdown.classList.remove('toggled-on');
                        // Remove hover-intent class from previous sibling
                        previousItemDropdown.classList.remove('hover-intent');
                        // Change toggle button aria-label
                        // eslint-disable-next-line camelcase, no-undef
                        previousItem.querySelector('.dropdown-toggle').setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${previousItem.querySelector('.dropdown-item').innerText}`);
                        // Change toggle button aria-expanded
                        previousItem.querySelector('.dropdown-toggle').setAttribute('aria-expanded', 'false');
                        // Toggle toggled-on class on previousItem
                        previousItem.querySelector('.dropdown-toggle').classList.remove('toggled-on');
                    }
                }
            }
        });
        // NVDA supported keyboard navigation (NVDA and mobile need click event to work)
        (0, $ce5c042a53fc3c5f$export$2e2bcd8739ae039)(item, [
            'click',
            'keydown',
            'keypress'
        ], (e)=>{
            // Get this link
            const thisElement = e.target;
            // Get this menu-item
            const thisMenuItem = thisElement.parentNode;
            // Define the elements of this dropdown
            const firstDropdown = thisElement.parentNode.parentNode.parentNode.querySelector('.sub-menu');
            const thisDropdown = thisElement.nextElementSibling;
            const dropdownToggleButton = thisElement.parentNode.parentNode.parentNode.querySelector('.dropdown-toggle');
            // Remove removing-hover class
            thisElement.classList.remove('removing-hover');
            thisMenuItem.parentNode.classList.remove('removing-hover');
            // Open navigation on Enter, e.type click is for NVDA
            if (e.key === 'Enter' || e.type === 'click') {
                // If this item is a hyperlink, do nothing. We want to use Enter only with buttons
                if (thisElement.tagName === 'A') return;
                // If link label not found, do nothing
                if (!thisElement.parentNode.querySelector('.dropdown-item')) return;
                // Get the link label of .dropdown link
                const linkLabel = thisElement.parentNode.querySelector('.dropdown-item').innerText;
                // Toggle toggled-on class
                thisElement.classList.toggle('toggled-on');
                // If aria-expanded is false, set it to true
                if (thisElement.getAttribute('aria-expanded') === 'false') {
                    // Set aria-expanded to true
                    thisElement.setAttribute('aria-expanded', 'true');
                    // Set aria-label of the dropdown button
                    // eslint-disable-next-line camelcase, no-undef
                    thisElement.setAttribute('aria-label', `${air_light_screenReaderText.collapse_for} ${linkLabel}`);
                } else {
                    // Set aria-expanded to false
                    thisElement.setAttribute('aria-expanded', 'false');
                    // Set aria-label of the dropdown button
                    // eslint-disable-next-line camelcase, no-undef
                    thisElement.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                }
                // Toggle the dropdown
                if (thisDropdown && !thisDropdown.classList.contains('toggled-on')) {
                    // Add hover-intent class to this menu-item
                    thisMenuItem.classList.add('hover-intent');
                    // Add toggled-on class to this dropdown
                    thisDropdown.classList.add('toggled-on');
                } else {
                    // Remove hover-intent class from this menu-item
                    if (thisMenuItem) thisMenuItem.classList.remove('hover-intent');
                    // Remove toggled-on class from this dropdown
                    if (thisDropdown) thisDropdown.classList.remove('toggled-on');
                }
            }
            // Close navigation on Escape
            if (e.key === 'Escape') {
                // Close mobile nav if no sub-menu is open
                if (thisElement.parentNode.parentNode.id === 'main-menu' && !thisElement.parentNode.classList.contains('toggled-on')) {
                    document.body.classList.remove('js-nav-active');
                    // Move focus back to nav-toggle
                    document.getElementById('nav-toggle').focus();
                }
                // If we're on main level and nav item is not open, do nothing
                if (thisElement.parentNode.parentNode.id === 'main-menu' && !thisElement.parentNode.classList.contains('hover-intent')) return;
                // Remove toggled-on classes from this dropdown
                firstDropdown.classList.remove('toggled-on');
                // Remove hover-intent classes from the current menu-item
                thisMenuItem.classList.remove('hover-intent');
                // Hide menu if we're on second level
                thisMenuItem.parentNode.parentNode.classList.remove('hover-intent');
                // Set aria expanded attribute to false
                dropdownToggleButton.setAttribute('aria-expanded', 'false');
                // Remove toggled-on
                dropdownToggleButton.classList.remove('toggled-on');
                // Get the link label of dropdown link
                const linkLabel = thisElement.parentNode.querySelector('.dropdown-item').innerText;
                // Set aria label attribute
                // eslint-disable-next-line camelcase, no-undef
                dropdownToggleButton.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                // If we're on button, add aria-expanded to false
                if (thisElement.classList.contains('dropdown-toggle')) {
                    thisElement.setAttribute('aria-expanded', 'false');
                    // Set aria-label of the dropdown button
                    // eslint-disable-next-line camelcase, no-undef
                    thisElement.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                }
                // Move focus back to previous .dropdown-toggle, but only if we're not on main level
                if (thisElement.parentNode.parentNode.id !== 'main-menu') // Delay toggling for NVDA for 100 ms
                setTimeout(()=>{
                    dropdownToggleButton.focus();
                }, 100);
            }
            // If no arrow keys used, do not continue
            if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            // Arrow keys
            switch(e.code){
                // ArrowUp
                case 'ArrowUp':
                    // Stop propagation
                    e.stopPropagation();
                    // Stop scrolling
                    e.preventDefault();
                    // If we're on the sub-menu, move up
                    if (thisElement.parentNode.parentNode.previousElementSibling && thisElement.parentNode.parentNode.previousElementSibling.classList.contains('dropdown-toggle')) // Focus to the previous link
                    thisElement.parentNode.parentNode.previousElementSibling.focus();
                    // If this is a .dropdown-toggle button and aria-expanded is true, close the dropdown
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true') {
                        // Remove hover-intent class from this menu-item
                        thisMenuItem.classList.remove('hover-intent');
                        // Remove toggled-on class from this dropdown
                        thisDropdown.classList.remove('toggled-on');
                        // Set aria-expanded attribute to false
                        thisElement.setAttribute('aria-expanded', 'false');
                        // Get the link label of .dropdown link
                        const linkLabel = thisElement.parentNode.querySelector('.dropdown-item').innerText;
                        // Set aria-label of the dropdown button
                        // eslint-disable-next-line camelcase, no-undef
                        thisElement.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                        // Move focus back to previous .dropdown-toggle
                        dropdownToggleButton.focus();
                    }
                    // If this is a correct element, focus to the previous link
                    if (thisElement.tagName === 'A' || thisElement.tagName === 'BUTTON') {
                        // If there is no previous items, bail
                        if (!thisElement.parentNode.previousElementSibling) return;
                        // Get the previous link
                        const previousLink = thisElement.parentNode.previousElementSibling.querySelector('a');
                        // Get .dropdown-toggle element
                        const previousToggle = thisElement.parentNode.previousElementSibling.querySelector('.dropdown-toggle');
                        // If previous element is .dropdown-toggle element, focus to it
                        if (previousToggle && !thisElement.querySelector('.dropdown-toggle')) previousToggle.focus();
                        else // If previous element is a link, focus to it
                        previousLink.focus();
                    }
                    break;
                // ArrowDown
                case 'ArrowDown':
                    // Stop propagation
                    e.stopPropagation();
                    // Stop scrolling
                    e.preventDefault();
                    // If we're on the sub-menu, move down
                    if (thisElement.parentNode.parentNode.nextElementSibling && thisElement.parentNode.parentNode.nextElementSibling.classList.contains('dropdown-toggle')) // Focus to the next link
                    thisElement.parentNode.parentNode.nextElementSibling.focus();
                    // If this is a .dropdown-toggle button and aria-expanded is true, move down
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true') // Focus to the next link
                    thisElement.parentNode.querySelector('.sub-menu').querySelector('li:first-child').querySelector('a').focus();
                    // If this is a .dropdown-toggle button and aria-expanded is false, open sub-menu
                    // (if we are not inside sub-menu)
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'false' && !thisElement.parentNode.parentNode.classList.contains('sub-menu')) {
                        // Open sub-menu
                        thisElement.click();
                        // Focus to the next link under sub-menu
                        thisElement.parentNode.querySelector('.sub-menu').querySelector('li:first-child').querySelector('a').focus();
                        // Don't do anything else
                        return;
                    }
                    // If we are in fact in sub menu, move to next link
                    if (thisElement.parentNode.parentNode.classList.contains('sub-menu')) // Focus to the next link
                    thisElement.parentNode.nextElementSibling.querySelector('a').focus();
                    // If this is a correct element, focus to the next link
                    if ((thisElement.tagName === 'A' || thisElement.tagName === 'BUTTON') && !thisElement.classList.contains('dropdown-toggle')) {
                        // If there is no next items, bail
                        if (!thisElement.parentNode.nextElementSibling) return;
                        // Get the next link
                        const nextLink = thisElement.parentNode.nextElementSibling.querySelector('a');
                        // Get .dropdown-toggle element
                        let nextToggle = thisElement.parentNode.nextElementSibling.querySelector('.dropdown-toggle');
                        // If this has class .dropdown-item, jump to the next .dropdown-toggle
                        if (thisElement.classList.contains('dropdown-item')) // If there is a toggle
                        {
                            if (thisElement.nextElementSibling) {
                                // Get the dropdown-toggle element
                                nextToggle = thisElement.nextElementSibling;
                                // If next element is .dropdown-toggle element, focus to it
                                if (nextToggle) nextToggle.focus();
                            }
                        }
                        // If next element is .dropdown-toggle element, focus to it
                        if (nextToggle && !thisElement.querySelector('.dropdown-toggle')) nextToggle.focus();
                        else // If next element is a link, focus to it
                        nextLink.focus();
                    }
                    break;
                // ArrowLeft
                case 'ArrowLeft':
                    // Stop propagation
                    e.stopPropagation();
                    // Stop scrolling
                    e.preventDefault();
                    // If we are on the first link, move to the dropdown-toggle and close menu
                    if (thisElement.parentNode.previousElementSibling === null && thisElement.parentNode.parentNode.id !== 'main-menu') {
                        // Focus to the previous link
                        thisElement.parentNode.parentNode.parentNode.querySelector('.dropdown-toggle').focus();
                        // Close the dropdown
                        thisElement.parentNode.parentNode.parentNode.querySelector('.dropdown-toggle').click();
                        // Don't do anything else
                        return;
                    }
                    // If this is a .dropdown-toggle button and aria-expanded is true, move left
                    if (thisElement.parentNode.previousElementSibling && thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true' && thisElement.parentNode.parentNode.id !== 'main-menu') // Focus to the previous link
                    thisElement.parentNode.previousElementSibling.querySelector('a').focus();
                    // If this is a .dropdown-toggle button and aria-expanded is false, close the dropdown
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'false' && thisElement.parentNode.parentNode.id !== 'main-menu') {
                        // Remove hover-intent class from this menu-item
                        thisMenuItem.classList.remove('hover-intent');
                        // Remove toggled-on class from this dropdown
                        thisDropdown.classList.remove('toggled-on');
                        // Set aria-expanded attribute to false
                        thisElement.setAttribute('aria-expanded', 'false');
                        // Get the link label of .dropdown link
                        const linkLabel = thisElement.parentNode.querySelector('.dropdown-item').innerText;
                        // Set aria-label of the dropdown button
                        // eslint-disable-next-line camelcase, no-undef
                        thisElement.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                        // Move focus back to previous .dropdown-toggle
                        dropdownToggleButton.focus();
                    }
                    // If this is a correct element, focus to the previous link
                    if (thisElement.tagName === 'A' || thisElement.tagName === 'BUTTON') {
                        // If this is a .dropdown-toggle button and aria-expanded is false,
                        // move to the link directly before it
                        if (thisElement.previousElementSibling && thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'false') {
                            // Focus to the previous link
                            thisElement.previousElementSibling.focus();
                            // Don't do anything else
                            return;
                        }
                        // If there is no previous items, bail
                        if (!thisElement.parentNode.previousElementSibling) return;
                        // Get the previous link
                        const previousLink = thisElement.parentNode.previousElementSibling.querySelector('a');
                        // Get .dropdown-toggle element
                        const previousToggle = thisElement.parentNode.previousElementSibling.querySelector('.dropdown-toggle');
                        // If previous element is .dropdown-toggle element, focus to it
                        if (previousToggle) previousToggle.focus();
                        else // If previous element is a link, focus to it
                        previousLink.focus();
                    }
                    break;
                // ArrowRight
                case 'ArrowRight':
                    // Stop propagation
                    e.stopPropagation();
                    // Stop scrolling
                    e.preventDefault();
                    // If this is a .dropdown-toggle button and aria-expanded is true, move right
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true' && thisElement.parentNode.parentNode.id !== 'main-menu') // Focus to the next link
                    thisElement.parentNode.querySelector('.sub-menu').querySelector('li:first-child').querySelector('a').focus();
                    // If this has class .dropdown-item, jump to the next .dropdown-toggle
                    if (thisElement.nextElementSibling) {
                        thisElement.nextElementSibling.focus();
                        // Disable other actions if this is a .dropdown-item
                        if (thisElement.classList.contains('dropdown-item')) return;
                    }
                    // If this is a .dropdown-toggle button and aria-expanded is false, open sub-menu
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'false' && thisElement.parentNode.parentNode.id !== 'main-menu') {
                        // Open sub-menu
                        thisElement.click();
                        // Do nothing else
                        return;
                    }
                    // If this is a dropdown-toggle button and aria-expanded is true, move right
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true' && thisElement.parentNode.parentNode.id !== 'main-menu') {
                        // Focus to the next link
                        thisElement.parentNode.querySelector('.sub-menu').querySelector('li:first-child').querySelector('a').focus();
                        // Don't do anything else
                        return;
                    }
                    // If this is a correct element, focus to the previous link
                    if (thisElement.tagName === 'A' || thisElement.tagName === 'BUTTON') {
                        // If there is no next items, bail
                        if (!thisElement.parentNode.nextElementSibling) return;
                        // Get the next link
                        const nextLink = thisElement.parentNode.nextElementSibling.querySelector('a');
                        // Get .dropdown-toggle element
                        const nextToggle = thisElement.parentNode.nextElementSibling.querySelector('.dropdown-toggle');
                        // If next element is .dropdown-toggle element, focus to it
                        if (nextToggle) nextToggle.focus();
                        else // If next element is a link, focus to it
                        nextLink.focus();
                    }
                    break;
                default:
                    break;
            }
        });
    });
}
var $0ae90c2232c0c773$export$2e2bcd8739ae039 = $0ae90c2232c0c773$var$a11yDropdownMenuKeyboardNavigation;


function $bb3919502b98ced2$var$convertDropdownMenuItems(items) {
    items.forEach((li)=>{
        // Get dropdown toggle button
        const dropdownToggle = li.querySelector('.dropdown-toggle');
        // Get dropdown menu item data
        const menuItemTitle = li.querySelector('a > span').innerHTML;
        const menuItemLinkElement = li.querySelector('a');
        const menuItemLink = menuItemLinkElement.href;
        // Remove dropdown menu item link
        menuItemLinkElement.remove();
        // Add dropdown menu item title to dropdown toggle button
        dropdownToggle.innerHTML = menuItemTitle;
        // Create new nav element
        const navElement = document.createElement('li');
        navElement.classList.add('menu-item');
        // Add dropdown menu item data to nav element
        // Create elements
        const navElementLink = document.createElement('a');
        const navElementLinkSpan = document.createElement('span');
        // Add data to elements
        // Span
        navElementLinkSpan.innerHTML = menuItemTitle;
        navElementLinkSpan.setAttribute('itemprop', 'name');
        // Link
        navElementLink.setAttribute('itemprop', 'url');
        navElementLink.href = menuItemLink;
        navElementLink.classList.add('dropdown-item');
        // Append elements
        navElementLink.appendChild(navElementLinkSpan);
        navElement.appendChild(navElementLink);
        // Get the sub menu first child and add the new nav element before it
        const subMenuFirstChild = li.querySelector('.sub-menu > li');
        const subMenu = li.querySelector('.sub-menu');
        subMenu.insertBefore(navElement, subMenuFirstChild);
    });
}
var $bb3919502b98ced2$export$2e2bcd8739ae039 = $bb3919502b98ced2$var$convertDropdownMenuItems;


function $300aff5b991bc5ca$var$closeSubMenu(li) {
    // If menu item is not a dropdown then do nothing
    if (!li.querySelector('.dropdown-toggle') && !li.querySelector('.sub-menu')) return;
    // Get the dropdown-button (.menu-item-clickable in click nav, .dropdown-toggle in hover nav)
    const dropdownButton = li.querySelector('.menu-item-clickable') || li.querySelector('.dropdown-toggle');
    // Get the submenu
    const subMenu = li.querySelector('.sub-menu');
    // If the dropdown-menu is not open, bail
    if (!subMenu.classList.contains('toggled-on')) return;
    // Remove the open class from the dropdown-menu
    subMenu.classList.remove('toggled-on');
    // Remove the open class from the dropdown-button
    dropdownButton.classList.remove('toggled-on');
    // Remove the aria-expanded attribute from the dropdown-button
    dropdownButton.setAttribute('aria-expanded', 'false');
    // Get the link text that is children of this item
    const linkText = dropdownButton.innerHTML;
    // Add the aria-label to the dropdown button
    // eslint-disable-next-line camelcase, no-undef
    dropdownButton.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkText}`);
}
var $300aff5b991bc5ca$export$2e2bcd8739ae039 = $300aff5b991bc5ca$var$closeSubMenu;


function $bfc9801624cecd2f$var$closeSubMenuHandler(items) {
    // Close open dropdowns when clicking outside of the menu
    const page = document.getElementById('page');
    page.addEventListener('click', (e)=>{
        // If the click is inside the menu, bail
        if (e.target.closest('.menu-items')) return;
        items.forEach((li)=>{
            (0, $300aff5b991bc5ca$export$2e2bcd8739ae039)(li);
        });
    });
    // Close open dropdown when pressing escape
    items.forEach((li)=>{
        li.addEventListener('keydown', (keydownMouseoverEvent)=>{
            if (keydownMouseoverEvent.key === 'Escape') (0, $300aff5b991bc5ca$export$2e2bcd8739ae039)(li);
        });
    });
    // Close other dropdowns when opening a new one
    items.forEach((li)=>{
        // Bail if no dropdown
        if (!li.classList.contains('menu-item-has-children')) return;
        const dropdownToggle = li.querySelector('.menu-item-clickable') || li.querySelector('.dropdown-toggle');
        const sameLevelDropdowns = li.parentNode.querySelectorAll(':scope > .menu-item-has-children');
        // Add event listener to dropdown toggle
        dropdownToggle.addEventListener('click', ()=>{
            // We want to close other dropdowns only when a new one is opened
            if (!dropdownToggle.classList.contains('toggled-on')) return;
            sameLevelDropdowns.forEach((sameLevelDropdown)=>{
                if (sameLevelDropdown !== li) {
                    // Close all other sub level dropdowns
                    sameLevelDropdown.querySelectorAll('.menu-item').forEach((subLi)=>{
                        (0, $300aff5b991bc5ca$export$2e2bcd8739ae039)(subLi);
                    });
                    // Close other same level dropdowns
                    (0, $300aff5b991bc5ca$export$2e2bcd8739ae039)(sameLevelDropdown);
                }
            });
        });
    });
}
var $bfc9801624cecd2f$export$2e2bcd8739ae039 = $bfc9801624cecd2f$var$closeSubMenuHandler;


// Add proper link labels for screen readers
function $f52dd46d4f4c1fa8$var$a11yAddDropdownToggleLabelsClick(items) {
    items.forEach((li)=>{
        // If .dropdown-toggle does not exist then do nothing
        if (!li.querySelector('.dropdown-toggle')) return;
        // Add helper class to dropdown-toggle
        li.querySelector('.dropdown-toggle').classList.add('menu-item-clickable');
        // Remove .dropdown-toggle class
        li.querySelector('.dropdown-toggle').classList.remove('dropdown-toggle');
        // Get the dropdown-button
        const dropdownButton = li.querySelector('.menu-item-clickable');
        // Get the link text that is children of this item
        const linkText = dropdownButton.innerHTML;
        // Add the aria-label to the dropdown button
        // eslint-disable-next-line camelcase, no-undef
        dropdownButton.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkText}`);
    });
}
var $f52dd46d4f4c1fa8$export$2e2bcd8739ae039 = $f52dd46d4f4c1fa8$var$a11yAddDropdownToggleLabelsClick;


// Import required modules

// Accessible keyboard navigation for dropdown menus
function $d3b791b7cd176b17$var$a11yDropdownMenuKeyboardNavigationClick(items, focusableElements) {
    focusableElements.forEach((item)=>{
        item.addEventListener('keyup', (e)=>{
            // Get this item
            const thisElement = e.target;
            // Get this menu-item
            // eslint-disable-next-line no-unused-vars
            const thisMenuItem = thisElement.parentNode;
            // Close previous dropdown if this parent contains id main-menu
            if (thisElement.parentNode.parentNode.id === 'main-menu' || thisElement.classList.contains('button-nav') && thisElement.parentNode.parentNode.id === 'main-menu') // If we have previous item
            {
                if (thisElement.parentNode.previousElementSibling) {
                    // Get the previous item
                    const previousItem = thisElement.parentNode.previousElementSibling;
                    // Get main level sub-menu
                    const mainLevelSubMenu = previousItem.querySelector('.sub-menu');
                    // If sub-menu found, close nested sub-menus first
                    if (mainLevelSubMenu && mainLevelSubMenu.querySelectorAll('.menu-item-has-children')) mainLevelSubMenu.querySelectorAll('.menu-item-has-children').forEach((subMenu)=>{
                        // Get the previous item's dropdown
                        const previousItemDropdownToggle = subMenu.querySelector('.dropdown-toggle');
                        const previousItemDropdown = subMenu.querySelector('.sub-menu');
                        // Remove toggled-on class from previous item button
                        previousItemDropdownToggle.classList.remove('toggled-on');
                        // Remove toggled-on class from previous sibling
                        previousItemDropdown.classList.remove('toggled-on');
                        // Change toggle button aria-label
                        // eslint-disable-next-line camelcase, no-undef
                        previousItemDropdownToggle.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${previousItemDropdownToggle.innerText}`);
                        // Change toggle button aria-expanded
                        previousItemDropdownToggle.setAttribute('aria-expanded', 'false');
                    });
                    // Close main level sub-menu
                    const previousItemDropdownToggle = previousItem.querySelector('.dropdown-toggle');
                    const previousItemDropdown = previousItem.querySelector('.sub-menu');
                    if (previousItemDropdownToggle && previousItemDropdown) {
                        // Remove toggled-on class from previous item button
                        previousItemDropdownToggle.classList.remove('toggled-on');
                        // Remove toggled-on class from previous sibling
                        previousItemDropdown.classList.remove('toggled-on');
                        // Change toggle button aria-label
                        // eslint-disable-next-line camelcase, no-undef
                        previousItemDropdownToggle.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${previousItemDropdownToggle.innerText}`);
                        // Change toggle button aria-expanded
                        previousItemDropdownToggle.setAttribute('aria-expanded', 'false');
                    }
                }
            }
        });
        // NVDA supported keyboard navigation (NVDA and mobile need click event to work)
        (0, $ce5c042a53fc3c5f$export$2e2bcd8739ae039)(item, [
            'click',
            'keydown',
            'keypress'
        ], (e)=>{
            // Get this link or button
            const thisElement = e.target;
            // Define the elements of this dropdown
            const firstDropdown = thisElement.parentNode.parentNode.parentNode.querySelector('.sub-menu');
            const thisDropdown = thisElement.nextElementSibling;
            const dropdownToggleButton = thisElement.parentNode.parentNode.parentNode.querySelector('.dropdown-toggle');
            // Open navigation on Enter, e.type click is for NVDA
            if (e.key === 'Enter' || e.type === 'click') {
                // If this item is a hyperlink, do nothing. We want to use Enter only with buttons
                if (thisElement.tagName === 'A') return;
                // Get the text of button
                const linkLabel = thisElement.innerText;
                // Toggle toggled-on class
                thisElement.classList.toggle('toggled-on');
                // If aria-expanded is false, set it to true
                if (thisElement.getAttribute('aria-expanded') === 'false') {
                    // Set aria-expanded to true
                    thisElement.setAttribute('aria-expanded', 'true');
                    // Set aria-label of the dropdown button
                    // eslint-disable-next-line camelcase, no-undef
                    thisElement.setAttribute('aria-label', `${air_light_screenReaderText.collapse_for} ${linkLabel}`);
                } else {
                    // Set aria-expanded to false
                    thisElement.setAttribute('aria-expanded', 'false');
                    // Set aria-label of the dropdown button
                    // eslint-disable-next-line camelcase, no-undef
                    thisElement.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                }
                // Toggle the dropdown
                if (thisDropdown && !thisDropdown.classList.contains('toggled-on')) // Add toggled-on class to this dropdown
                thisDropdown.classList.add('toggled-on');
                else // Remove toggled-on class from this dropdown
                // eslint-disable-next-line no-lonely-if
                if (thisDropdown) thisDropdown.classList.remove('toggled-on');
            }
            // Close navigation on Escape
            if (e.key === 'Escape') {
                // Close mobile nav if no sub-menu is open
                if (thisElement.parentNode.parentNode.id === 'main-menu' && !thisElement.parentNode.classList.contains('toggled-on')) {
                    document.body.classList.remove('js-nav-active');
                    // Move focus back to nav-toggle
                    document.getElementById('nav-toggle').focus();
                }
                // If we're on main level and nav item is not open, do nothing
                if (thisElement.parentNode.parentNode.id === 'main-menu' && !thisElement.parentNode.classList.contains('toggled-on')) return;
                // Remove toggled-on classes from this dropdown
                firstDropdown.classList.remove('toggled-on');
                // Set aria expanded attribute to false
                dropdownToggleButton.setAttribute('aria-expanded', 'false');
                // Remove toggled-on
                dropdownToggleButton.classList.remove('toggled-on');
                // Get the link label of dropdown link
                const linkLabel = thisElement.parentNode.querySelector('.dropdown-item').innerText;
                // Set aria label attribute
                // eslint-disable-next-line camelcase, no-undef
                dropdownToggleButton.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                // If we're on button, add aria-expanded to false
                if (thisElement.classList.contains('dropdown-toggle')) {
                    thisElement.setAttribute('aria-expanded', 'false');
                    // Set aria-label of the dropdown button
                    // eslint-disable-next-line camelcase, no-undef
                    thisElement.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                }
                // Move focus back to previous .dropdown-toggle, but only if we're not on main level
                if (thisElement.parentNode.parentNode.id !== 'main-menu') // Delay toggling for NVDA for 100 ms
                setTimeout(()=>{
                    dropdownToggleButton.focus();
                }, 100);
            }
            // If no arrow keys used, do not continue
            if (e.key !== 'ArrowUp' && e.key !== 'ArrowDown' && e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
            // Arrow keys
            switch(e.code){
                // ArrowUp
                case 'ArrowUp':
                    // Stop propagation
                    e.stopPropagation();
                    // Stop scrolling
                    e.preventDefault();
                    // If we're on the sub-menu, move up
                    if (thisElement.parentNode.parentNode.previousElementSibling && thisElement.parentNode.parentNode.previousElementSibling.classList.contains('dropdown-toggle')) // Focus to the previous link
                    thisElement.parentNode.parentNode.previousElementSibling.focus();
                    // If this is a .dropdown-toggle button and aria-expanded is true, close the dropdown
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true') {
                        // Remove toggled-on class from this dropdown
                        thisDropdown.classList.remove('toggled-on');
                        thisElement.classList.remove('toggled-on');
                        // Set aria-expanded attribute to false
                        thisElement.setAttribute('aria-expanded', 'false');
                        // Get the link label of .dropdown link
                        const linkLabel = thisElement.parentNode.querySelector('.dropdown-item').innerText;
                        // Set aria-label of the dropdown button
                        // eslint-disable-next-line camelcase, no-undef
                        thisElement.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                        // Move focus back to previous .dropdown-toggle
                        dropdownToggleButton.focus();
                    }
                    // If this is a correct element, focus to the previous link
                    if (thisElement.tagName === 'A' || thisElement.tagName === 'BUTTON') {
                        // If there is no previous items, bail
                        if (!thisElement.parentNode.previousElementSibling) return;
                        // Get the previous link
                        const previousLink = thisElement.parentNode.previousElementSibling.querySelector('a');
                        // Get .dropdown-toggle element
                        const previousToggle = thisElement.parentNode.previousElementSibling.querySelector('.dropdown-toggle');
                        // If previous element is .dropdown-toggle element, focus to it
                        if (previousToggle && !thisElement.querySelector('.dropdown-toggle')) previousToggle.focus();
                        else // If previous element is a link, focus to it
                        previousLink.focus();
                    }
                    break;
                // ArrowDown
                case 'ArrowDown':
                    // Stop propagation
                    e.stopPropagation();
                    // Stop scrolling
                    e.preventDefault();
                    // If we're on the sub-menu, move down
                    if (thisElement.parentNode.parentNode.nextElementSibling && thisElement.parentNode.parentNode.nextElementSibling.classList.contains('dropdown-toggle')) // Focus to the next link
                    thisElement.parentNode.parentNode.nextElementSibling.focus();
                    // If this is a .dropdown-toggle button and aria-expanded is true, move down
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true') // Focus to the next link
                    thisElement.parentNode.querySelector('.sub-menu').querySelector('li:first-child').querySelector('a').focus();
                    // If this is a .dropdown-toggle button and aria-expanded is false, open sub-menu
                    // (if we are not inside sub-menu)
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'false' && !thisElement.parentNode.parentNode.classList.contains('sub-menu')) {
                        // Open sub-menu
                        thisElement.click();
                        // Focus to the next link under sub-menu
                        thisElement.parentNode.querySelector('.sub-menu').querySelector('li:first-child').querySelector('a').focus();
                        // Don't do anything else
                        return;
                    }
                    // If we are in fact in sub menu, move to next link
                    if (thisElement.parentNode.parentNode.classList.contains('sub-menu')) {
                        // Focus to the next link or .dropdown-toggle
                        // Generally focus the next link
                        if (thisElement.parentNode.nextElementSibling.querySelector(':scope > a')) thisElement.parentNode.nextElementSibling.querySelector(':scope > a').focus();
                        else // If there is no next link, focus to the next .dropdown-toggle
                        thisElement.parentNode.nextElementSibling.querySelector('.dropdown-toggle').focus();
                    }
                    // If this is a correct element, focus to the next link
                    if ((thisElement.tagName === 'A' || thisElement.tagName === 'BUTTON') && !thisElement.classList.contains('dropdown-toggle')) {
                        // If there is no next items, bail
                        if (!thisElement.parentNode.nextElementSibling) return;
                        // Get the next link
                        const nextLink = thisElement.parentNode.nextElementSibling.querySelector('a');
                        // Get .dropdown-toggle element
                        let nextToggle = thisElement.parentNode.nextElementSibling.querySelector('.dropdown-toggle');
                        // If this has class .dropdown-item, jump to the next .dropdown-toggle
                        if (thisElement.classList.contains('dropdown-item')) // If there is a toggle
                        {
                            if (thisElement.nextElementSibling) {
                                // Get the dropdown-toggle element
                                nextToggle = thisElement.nextElementSibling;
                                // If next element is .dropdown-toggle element, focus to it
                                if (nextToggle) nextToggle.focus();
                            }
                        }
                        // If next element is .dropdown-toggle element, focus to it
                        if (nextToggle && !thisElement.querySelector('.dropdown-toggle')) nextToggle.focus();
                        else // If next element is a link, focus to it
                        nextLink.focus();
                    }
                    break;
                // ArrowLeft
                case 'ArrowLeft':
                    // Stop propagation
                    e.stopPropagation();
                    // Stop scrolling
                    e.preventDefault();
                    // If we are on the first link, move to the dropdown-toggle and close menu
                    if (thisElement.parentNode.previousElementSibling === null && thisElement.parentNode.parentNode.id !== 'main-menu') {
                        // Focus to the previous link
                        thisElement.parentNode.parentNode.parentNode.querySelector('.dropdown-toggle').focus();
                        // Close the dropdown
                        thisElement.parentNode.parentNode.parentNode.querySelector('.dropdown-toggle').click();
                        // Don't do anything else
                        return;
                    }
                    // If this is a .dropdown-toggle button and aria-expanded is true, move left
                    if (thisElement.parentNode.previousElementSibling && thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true' && thisElement.parentNode.parentNode.id !== 'main-menu') // Focus to the previous link
                    thisElement.parentNode.previousElementSibling.querySelector('a').focus();
                    // If this is a .dropdown-toggle button and aria-expanded is false, close the dropdown
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'false' && thisElement.parentNode.parentNode.id !== 'main-menu') {
                        // Remove toggled-on class from this dropdown
                        thisDropdown.classList.remove('toggled-on');
                        // Set aria-expanded attribute to false
                        thisElement.setAttribute('aria-expanded', 'false');
                        // Get the link label of .dropdown link
                        const linkLabel = thisElement.parentNode.querySelector('.dropdown-item').innerText;
                        // Set aria-label of the dropdown button
                        // eslint-disable-next-line camelcase, no-undef
                        thisElement.setAttribute('aria-label', `${air_light_screenReaderText.expand_for} ${linkLabel}`);
                        // Move focus back to previous .dropdown-toggle
                        dropdownToggleButton.focus();
                    }
                    // If this is a correct element, focus to the previous link
                    if (thisElement.tagName === 'A' || thisElement.tagName === 'BUTTON') {
                        // If this is a .dropdown-toggle button and aria-expanded is false,
                        // move to the link directly before it
                        if (thisElement.previousElementSibling && thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'false') {
                            // Focus to the previous link
                            thisElement.previousElementSibling.focus();
                            // Don't do anything else
                            return;
                        }
                        // If there is no previous items, bail
                        if (!thisElement.parentNode.previousElementSibling) return;
                        // Get the previous link
                        const previousLink = thisElement.parentNode.previousElementSibling.querySelector('a');
                        // Get .dropdown-toggle element
                        const previousToggle = thisElement.parentNode.previousElementSibling.querySelector('.dropdown-toggle');
                        // If previous element is .dropdown-toggle element, focus to it
                        if (previousToggle) previousToggle.focus();
                        else // If previous element is a link, focus to it
                        previousLink.focus();
                    }
                    break;
                // ArrowRight
                case 'ArrowRight':
                    // Stop propagation
                    e.stopPropagation();
                    // Stop scrolling
                    e.preventDefault();
                    // If this is a .dropdown-toggle button and aria-expanded is true, move right
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true' && thisElement.parentNode.parentNode.id !== 'main-menu') // Focus to the next link
                    thisElement.parentNode.querySelector('.sub-menu').querySelector('li:first-child').querySelector('a').focus();
                    // If this has class .dropdown-item, jump to the next .dropdown-toggle
                    if (thisElement.nextElementSibling) {
                        thisElement.nextElementSibling.focus();
                        // Disable other actions if this is a .dropdown-item
                        if (thisElement.classList.contains('dropdown-item')) return;
                    }
                    // If this is a .dropdown-toggle button and aria-expanded is false, open sub-menu
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'false' && thisElement.parentNode.parentNode.id !== 'main-menu') {
                        // Open sub-menu
                        thisElement.click();
                        // Do nothing else
                        return;
                    }
                    // If this is a dropdown-toggle button and aria-expanded is true, move right
                    if (thisElement.classList.contains('dropdown-toggle') && thisElement.getAttribute('aria-expanded') === 'true' && thisElement.parentNode.parentNode.id !== 'main-menu') {
                        // Focus to the next link
                        thisElement.parentNode.querySelector('.sub-menu').querySelector('li:first-child').querySelector('a').focus();
                        // Don't do anything else
                        return;
                    }
                    // If this is a correct element, focus to the previous link
                    if (thisElement.tagName === 'A' || thisElement.tagName === 'BUTTON') {
                        // If there is no next items, bail
                        if (!thisElement.parentNode.nextElementSibling) return;
                        // Get the next link
                        const nextLink = thisElement.parentNode.nextElementSibling.querySelector('a');
                        // Get .dropdown-toggle element
                        const nextToggle = thisElement.parentNode.nextElementSibling.querySelector('.dropdown-toggle');
                        // If next element is .dropdown-toggle element, focus to it
                        if (nextToggle) nextToggle.focus();
                        else // If next element is a link, focus to it
                        nextLink.focus();
                    }
                    break;
                default:
                    break;
            }
        });
    });
}
var $d3b791b7cd176b17$export$2e2bcd8739ae039 = $d3b791b7cd176b17$var$a11yDropdownMenuKeyboardNavigationClick;


const $d2563fe93513be8c$export$9c43844ef57ea1d0 = ()=>{
    const navPrimary = document.querySelector('.nav-primary');
    // If .nav-primary doesn't exist, don't continue
    if (!navPrimary) return;
    // Define globals
    const menuItems = navPrimary.querySelectorAll('.menu-item');
    // Define focusable elements on sub-menu (.menu-item a, .dropdown button)
    const focusableElementsforDropdown = document.querySelectorAll('.menu-item a, .dropdown button, .button-nav');
    // If main-menu is not found, bail
    if (!document.getElementById('main-menu')) return;
    // Dropdown menus
    (0, $968b082be717d119$export$2e2bcd8739ae039)(menuItems);
    (0, $0ae90c2232c0c773$export$2e2bcd8739ae039)(menuItems, focusableElementsforDropdown);
    // Dropdown on mouse hover
    (0, $08609567837f9fc3$export$2e2bcd8739ae039)(menuItems);
    // Check for submenu overflow
    (0, $53d3c8651e14ecb5$export$2e2bcd8739ae039)(menuItems);
};
const $d2563fe93513be8c$export$732b8fa89b3a0745 = ()=>{
    // If main-menu is not found, bail
    if (!document.getElementById('main-menu')) return;
    // Search for all menu items that have submenus
    const dropdownMenuItems = document.querySelectorAll('.menu-item-has-children');
    // Convert submenus to clickable elements
    (0, $bb3919502b98ced2$export$2e2bcd8739ae039)(dropdownMenuItems);
    // Define globals
    const menuItems = document.querySelectorAll('.menu-item');
    // Define focusable elements on sub-menu (.menu-item a, .dropdown button)
    const focusableElementsforDropdown = document.querySelectorAll('.menu-item a, .dropdown button, .button-nav');
    // Handle different scenarios when menus should be closed
    // Must be called before a11yAddDropdownToggleLabelsClick which renames .dropdown-toggle to .menu-item-clickable
    (0, $bfc9801624cecd2f$export$2e2bcd8739ae039)(menuItems);
    // Dropdown menus
    (0, $f52dd46d4f4c1fa8$export$2e2bcd8739ae039)(menuItems);
    (0, $d3b791b7cd176b17$export$2e2bcd8739ae039)(menuItems, focusableElementsforDropdown);
};
const $d2563fe93513be8c$export$3a2707b50c3b4a73 = ()=>{
    // If burger toggle is not found, bail
    if (!document.getElementById('nav-toggle')) {
        // eslint-disable-next-line no-console
        console.log('Warning: No nav-toggle found.');
        return;
    }
    function navToggle(e) {
        // If clicked with mouse or enter key
        if (e.type === 'click' || e.keyCode === 13) {
            // Activate nav
            document.body.classList.toggle('js-nav-active');
            // Toggle aria-expanded attribute, if it's false, change to true and vice versa
            if (document.getElementById('nav-toggle').getAttribute('aria-expanded') === 'false') document.getElementById('nav-toggle').setAttribute('aria-expanded', 'true');
            else document.getElementById('nav-toggle').setAttribute('aria-expanded', 'false');
            // Toggle aria-label
            // eslint-disable-next-line camelcase, no-undef
            if (document.getElementById('nav-toggle').getAttribute('aria-label') === air_light_screenReaderText.expand_toggle) // eslint-disable-next-line camelcase, no-undef
            document.getElementById('nav-toggle').setAttribute('aria-label', air_light_screenReaderText.collapse_toggle);
            else // eslint-disable-next-line camelcase, no-undef
            document.getElementById('nav-toggle').setAttribute('aria-label', air_light_screenReaderText.expand_toggle);
            // Center vertically the absolute positioned mobile dropdown toggles by setting fixed height
            (0, $ebdaf21019182232$export$2e2bcd8739ae039)();
            // Focusable elements
            const navContainer = document.getElementById('nav');
            const focusableElements = [
                ...navContainer.querySelectorAll('a, button, input, textarea, select, details, [tabindex]:not([tabindex="-1"])')
            ].filter((el)=>!el.hasAttribute('disabled')).filter((el)=>!!(el.offsetWidth || el.offsetHeight || el.getClientRects().length));
            focusableElements.forEach((menuItem)=>{
                menuItem.addEventListener('keydown', (0, $bd070018dfff8e4c$export$2e2bcd8739ae039));
            });
        }
    }
    // When clicking #nav-toggle, add .js-nav-active body class
    (0, $ce5c042a53fc3c5f$export$2e2bcd8739ae039)(document.getElementById('nav-toggle'), [
        'click',
        'keydown',
        'keypress'
    ], navToggle);
    // Clicking the dimmed backdrop behind the drawer closes it, same as
    // clicking the toggle itself - it's only clickable while the menu is
    // open (see .js-nav-active .menu-items-overlay in _nav-mobile.scss).
    const menuOverlay = document.getElementById('menu-items-overlay');
    if (menuOverlay) menuOverlay.addEventListener('click', ()=>document.getElementById('nav-toggle').click());
    // Get all dropdown-toggles
    const dropdownToggles = document.querySelectorAll('.dropdown-toggle');
    // Loop through dropdown-toggles
    dropdownToggles.forEach((dropdownToggle)=>{
        // When clicking a dropdown-toggle, add .js-dropdown-active class to the parent .menu-item
        (0, $ce5c042a53fc3c5f$export$2e2bcd8739ae039)(dropdownToggle, [
            'click',
            'keydown',
            'keypress'
        ], (0, $ebdaf21019182232$export$2e2bcd8739ae039));
    });
};
// Sticky navigation
// eslint-disable-next-line no-unused-vars
const $d2563fe93513be8c$export$19f6899aad5f4764 = ()=>{
    function initStickyNavStyles() {
        // Add default styles for sticky navigation as <style>
        const style = document.createElement('style');
        style.innerHTML = `
    .site-header {
      transition: all 100ms cubic-bezier(.4, 0, .2, 1);
      overflow: visible;
      width: 100%;
      z-index: 100;
    }

    .site-header.is-fixed {
      animation-duration: 300ms;
      animation-iteration-count: 1;
      animation-name: roll-in;
      background-color: var(--color-white);
      border-bottom: 1px solid var(--color-black);
      left: 0;
      position: fixed;
      top: 0;
    }

    @keyframes roll-in {
      0% {
        opacity: 0;
        top: -100%;
      }

      100% {
        opacity: 1;
        top: 0;
      }
    }`;
        document.head.appendChild(style);
    }
    function initStickyNav() {
        // Get --breakpoint-nav from CSS
        const breakpointNav = getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-nav');
        // Let's see if we are on mobile viewport
        const isMobile = window.matchMedia(`(max-width: ${breakpointNav})`).matches;
        // If things are not okay, bail
        if (isMobile) return;
        const siteHeader = document.querySelector('.site-header');
        const headerHeight = getComputedStyle(siteHeader).height.split('px')[0];
        const scrollValue = window.scrollY;
        if (scrollValue > headerHeight) siteHeader.classList.add('is-fixed');
        else if (scrollValue < headerHeight) siteHeader.classList.remove('is-fixed');
        if (window.pageYOffset > headerHeight) siteHeader.classList.add('is-fixed');
    }
    window.addEventListener('scroll', initStickyNav);
    window.addEventListener('DOMContentLoaded', initStickyNavStyles);
};
// Reinit some things
window.addEventListener('resize', ()=>{
    // Center vertically the absolute positioned mobile dropdown toggles by setting fixed height
    (0, $ebdaf21019182232$export$2e2bcd8739ae039)();
    // Check for submenu overflow
    (0, $53d3c8651e14ecb5$export$2e2bcd8739ae039)(document.querySelectorAll('.menu-item'));
});


/**
 * Behaviour for the internal /sistema-de-diseno reference page:
 * tabs switching, the cart-popup "copy code" button, and the button loading
 * demo (the reusable withButtonLoading lock itself lives in button.js).
 */ /**
 * Reusable loading/lock behaviour for .button-base buttons.
 * Import `withButtonLoading` anywhere a button triggers an async action
 * (add to cart, checkout submit, etc.) to show the spinner state and stop a
 * second click from firing the action again while it's in flight.
 */ /**
 * Runs `task` while the button is locked in its loading state, restoring the
 * button afterwards regardless of whether `task` resolves or rejects.
 * @param {HTMLButtonElement} button
 * @param {() => (void | Promise<void>)} task
 * @returns {Promise<void>}
 */ const $f34086fc9474d956$export$f284d97446e8b58d = async (button, task)=>{
    if (button.disabled) return;
    button.classList.add('is-loading');
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    try {
        await task();
    } finally{
        button.classList.remove('is-loading');
        button.disabled = false;
        button.removeAttribute('aria-busy');
    }
};
const $f34086fc9474d956$var$initButtonLoadingDemo = ()=>{
    const buttons = document.querySelectorAll('[data-loading-demo]');
    buttons.forEach((button)=>{
        button.addEventListener('click', ()=>{
            $f34086fc9474d956$export$f284d97446e8b58d(button, ()=>new Promise((resolve)=>{
                    setTimeout(resolve, 1500);
                }));
        });
    });
};
var $f34086fc9474d956$export$2e2bcd8739ae039 = $f34086fc9474d956$var$initButtonLoadingDemo;


const $950a97cef1f72e57$var$initDesignSystemTabs = ()=>{
    const tabGroups = document.querySelectorAll('[data-tabs]');
    tabGroups.forEach((group)=>{
        const triggers = group.querySelectorAll('[data-tab]');
        const panels = group.querySelectorAll('[data-tab-panel]');
        triggers.forEach((trigger)=>{
            trigger.addEventListener('click', ()=>{
                const { tab: tab } = trigger.dataset;
                triggers.forEach((item)=>{
                    item.classList.toggle('is-active', item === trigger);
                    item.setAttribute('aria-selected', item === trigger ? 'true' : 'false');
                });
                panels.forEach((panel)=>{
                    panel.classList.toggle('is-active', panel.dataset.tabPanel === tab);
                });
            });
        });
    });
};
// Delegated on document (not queried once and bound per-button) so it keeps
// working for [data-copy] buttons injected later - e.g. the cart
// drawer's discount code, whose content is replaced wholesale via AJAX
// (modules/cart-drawer.js) after every quantity change.
const $950a97cef1f72e57$var$initDesignSystemCopyCode = ()=>{
    document.addEventListener('click', (event)=>{
        const button = event.target.closest('[data-copy]');
        if (!button) return;
        const code = button.dataset.copy;
        const label = button.querySelector('[data-copy-label]');
        navigator.clipboard.writeText(code).then(()=>{
            button.classList.add('is-copied');
            if (label) label.textContent = 'Copiado';
            setTimeout(()=>{
                button.classList.remove('is-copied');
                if (label) label.textContent = 'Copiar';
            }, 2000);
        });
    });
};
const $950a97cef1f72e57$var$initDesignSystem = ()=>{
    $950a97cef1f72e57$var$initDesignSystemTabs();
    $950a97cef1f72e57$var$initDesignSystemCopyCode();
    (0, $f34086fc9474d956$export$2e2bcd8739ae039)();
};
var $950a97cef1f72e57$export$2e2bcd8739ae039 = $950a97cef1f72e57$var$initDesignSystem;


/**
 * Toggles `.is-scrolled` on `.site-header` once the page scrolls past the
 * top. On the front page the header starts transparent, overlaying the
 * hero (see layout/_site-header.scss `.home .site-header`); this class is
 * what switches it to a solid, fixed header while scrolling.
 */ const $c6fe2c653adac37e$var$initStickyHeader = ()=>{
    const header = document.querySelector('.site-header');
    if (!header) return;
    const toggleScrolledState = ()=>{
        header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    // Exposes the header's real rendered height as a custom property so other
    // sticky elements (e.g. .product-gallery) can offset below it instead of
    // overlapping - the header's height isn't a fixed value, it changes with
    // font loading and breakpoint-driven padding/logo size.
    const setHeaderHeightProperty = ()=>{
        document.documentElement.style.setProperty('--site-header-height', `${header.offsetHeight}px`);
    };
    toggleScrolledState();
    setHeaderHeightProperty();
    window.addEventListener('scroll', toggleScrolledState, {
        passive: true
    });
    window.addEventListener('resize', setHeaderHeightProperty);
    document.fonts?.ready.then(setHeaderHeightProperty);
};
var $c6fe2c653adac37e$export$2e2bcd8739ae039 = $c6fe2c653adac37e$var$initStickyHeader;


/**
 * Generic tabs component (see sass/components/_tabs.scss).
 * Scope markup with `data-tabs` on the wrapper, `data-tabs-trigger`
 * on each `.tabs-trigger` and `data-tabs-panel` on each
 * `.tabs-panel`, both sharing the same value to pair them up.
 */ const $5035070f670af9f6$var$initTabs = ()=>{
    const groups = document.querySelectorAll('[data-tabs]');
    groups.forEach((group)=>{
        const triggers = group.querySelectorAll('.tabs-trigger');
        const panels = group.querySelectorAll('.tabs-panel');
        triggers.forEach((trigger)=>{
            trigger.addEventListener('click', ()=>{
                const { tabsTrigger: target } = trigger.dataset;
                triggers.forEach((item)=>item.classList.toggle('is-active', item === trigger));
                panels.forEach((panel)=>panel.classList.toggle('is-active', panel.dataset.tabsPanel === target));
            });
        });
    });
};
var $5035070f670af9f6$export$2e2bcd8739ae039 = $5035070f670af9f6$var$initTabs;


/**
 * Single product gallery.
 *
 * Desktop: clicking a thumbnail shows that slide (thumbs/slides toggle
 * `.is-active` via CSS, see views/_product.scss).
 * Mobile: the track itself is a native horizontal scroll-snap carousel
 * (swipes like Instagram, no library needed); dots below stay in sync with
 * whichever slide is scrolled into view, and clicking a dot scrolls there.
 * Both: clicking a slide opens it full-size in a shared lightbox overlay
 * (video slides are excluded - they play in place instead).
 */ const $a8adb9e6b495cb5d$var$initProductGallery = ()=>{
    const galleries = document.querySelectorAll('[data-product-gallery]');
    galleries.forEach((gallery)=>{
        const track = gallery.querySelector('[data-product-gallery-track]');
        const slides = Array.from(gallery.querySelectorAll('[data-product-gallery-slide]'));
        const thumbs = Array.from(gallery.querySelectorAll('[data-product-gallery-thumb]'));
        const dots = Array.from(gallery.querySelectorAll('[data-product-gallery-dot]'));
        if (!track || !slides.length) return;
        const setActiveIndex = (index)=>{
            slides.forEach((slide, i)=>{
                slide.classList.toggle('is-active', i === index);
                // Pause any playing video left behind on a slide that's no longer
                // the active one, so it doesn't keep running (and making noise)
                // off-screen once another slide is shown.
                if (i !== index) slide.querySelector('video')?.pause();
            });
            thumbs.forEach((thumb, i)=>thumb.classList.toggle('is-active', i === index));
            dots.forEach((dot, i)=>dot.classList.toggle('is-active', i === index));
            // Keep the active thumb in view in its own scrollable rail (mobile:
            // horizontal strip, desktop: vertical column) whenever it changes,
            // whether from a thumb/dot click below or a swipe on the main track
            // (via the IntersectionObserver further down) - so a gallery with
            // more thumbs than fit on screen never settles mid-thumb.
            thumbs[index]?.scrollIntoView({
                behavior: 'smooth',
                inline: 'center',
                block: 'nearest'
            });
        };
        // Scrolling the track is what actually switches slides on mobile (the
        // IntersectionObserver below then calls setActiveIndex to match); on
        // desktop the track doesn't scroll, so this is a harmless no-op there
        // and setActiveIndex alone is what swaps the visible slide.
        const goToSlide = (index)=>{
            setActiveIndex(index);
            slides[index].scrollIntoView({
                behavior: 'smooth',
                inline: 'start',
                block: 'nearest'
            });
        };
        thumbs.forEach((thumb, index)=>{
            thumb.addEventListener('click', ()=>goToSlide(index));
        });
        dots.forEach((dot, index)=>{
            dot.addEventListener('click', ()=>goToSlide(index));
        });
        // Prev/next arrows over the main slide (see .product-gallery-nav) - just
        // another way to reach goToSlide, wrapping around at either end like a
        // regular slider.
        const mainPrev = gallery.querySelector('[data-product-gallery-prev]');
        const mainNext = gallery.querySelector('[data-product-gallery-next]');
        const activeIndex = ()=>slides.findIndex((slide)=>slide.classList.contains('is-active'));
        mainPrev?.addEventListener('click', ()=>{
            goToSlide((activeIndex() - 1 + slides.length) % slides.length);
        });
        mainNext?.addEventListener('click', ()=>{
            goToSlide((activeIndex() + 1) % slides.length);
        });
        if (dots.length) {
            const observer = new IntersectionObserver((entries)=>{
                entries.forEach((entry)=>{
                    if (entry.isIntersecting) setActiveIndex(slides.indexOf(entry.target));
                });
            }, {
                root: track,
                threshold: 0.6
            });
            slides.forEach((slide)=>observer.observe(slide));
        }
        // Thumbnail rail scroll arrows (desktop only - see views/_product.scss):
        // the rail scrolls internally with a fixed height instead of growing
        // past the main image and pushing the rest of the page down when there
        // are more thumbs than fit on screen.
        const thumbsRail = gallery.querySelector('[data-product-gallery-thumbs]');
        const thumbsWrap = gallery.querySelector('[data-product-gallery-thumbs-wrap]');
        const thumbsPrev = gallery.querySelector('[data-product-gallery-thumbs-prev]');
        const thumbsNext = gallery.querySelector('[data-product-gallery-thumbs-next]');
        if (thumbsRail && thumbsWrap && thumbsPrev && thumbsNext) {
            const updateThumbsArrows = ()=>{
                const { scrollTop: scrollTop, scrollHeight: scrollHeight, clientHeight: clientHeight } = thumbsRail;
                const hasOverflow = scrollHeight > clientHeight + 1;
                thumbsWrap.classList.toggle('has-overflow', hasOverflow);
                thumbsPrev.disabled = scrollTop <= 0;
                thumbsNext.disabled = scrollTop + clientHeight >= scrollHeight - 1;
            };
            thumbsPrev.addEventListener('click', ()=>{
                thumbsRail.scrollBy({
                    top: -thumbsRail.clientHeight * 0.8,
                    behavior: 'smooth'
                });
            });
            thumbsNext.addEventListener('click', ()=>{
                thumbsRail.scrollBy({
                    top: thumbsRail.clientHeight * 0.8,
                    behavior: 'smooth'
                });
            });
            thumbsRail.addEventListener('scroll', updateThumbsArrows);
            window.addEventListener('resize', updateThumbsArrows);
            updateThumbsArrows();
        }
    });
    const lightbox = document.querySelector('[data-product-gallery-lightbox]');
    const lightboxImage = lightbox?.querySelector('[data-product-gallery-lightbox-image]');
    const lightboxClose = lightbox?.querySelector('[data-product-gallery-lightbox-close]');
    const lightboxPrev = lightbox?.querySelector('[data-product-gallery-lightbox-prev]');
    const lightboxNext = lightbox?.querySelector('[data-product-gallery-lightbox-next]');
    if (!lightbox || !lightboxImage) return;
    // The other zoomable (non-video) slides from whichever gallery is open,
    // so prev/next can step through them - repopulated on each open in case
    // the page ever has more than one gallery.
    let lightboxSlides = [];
    let lightboxIndex = 0;
    const showLightboxSlide = (index)=>{
        const slide = lightboxSlides[index];
        if (!slide) return;
        lightboxIndex = index;
        const image = slide.querySelector('img');
        lightboxImage.src = slide.dataset.zoom || image.src;
        lightboxImage.alt = image.alt;
        const hasMultiple = lightboxSlides.length > 1;
        if (lightboxPrev) lightboxPrev.disabled = !hasMultiple;
        if (lightboxNext) lightboxNext.disabled = !hasMultiple;
    };
    const closeLightbox = ()=>{
        lightbox.hidden = true;
        lightboxImage.src = '';
    };
    document.querySelectorAll('[data-product-gallery-slide]:not(.is-video)').forEach((slide)=>{
        slide.addEventListener('click', ()=>{
            lightboxSlides = Array.from(slide.closest('[data-product-gallery]')?.querySelectorAll('[data-product-gallery-slide]:not(.is-video)') || [
                slide
            ]);
            showLightboxSlide(lightboxSlides.indexOf(slide));
            lightbox.hidden = false;
        });
    });
    lightboxPrev?.addEventListener('click', ()=>{
        showLightboxSlide((lightboxIndex - 1 + lightboxSlides.length) % lightboxSlides.length);
    });
    lightboxNext?.addEventListener('click', ()=>{
        showLightboxSlide((lightboxIndex + 1) % lightboxSlides.length);
    });
    lightboxClose?.addEventListener('click', closeLightbox);
    lightbox.addEventListener('click', (event)=>{
        if (event.target === lightbox) closeLightbox();
    });
    document.addEventListener('keydown', (event)=>{
        if (lightbox.hidden) return;
        if (event.key === 'Escape') closeLightbox();
        if (event.key === 'ArrowLeft') showLightboxSlide((lightboxIndex - 1 + lightboxSlides.length) % lightboxSlides.length);
        if (event.key === 'ArrowRight') showLightboxSlide((lightboxIndex + 1) % lightboxSlides.length);
    });
};
var $a8adb9e6b495cb5d$export$2e2bcd8739ae039 = $a8adb9e6b495cb5d$var$initProductGallery;


/**
 * Gallery strip (product page): most browsers besides Safari
 * can't decode QuickTime/HEVC `.mov` clips inside a <video> element, which
 * would otherwise leave that slot blank. When a video's source can't be
 * played, swap it for its own `poster` image instead.
 */ const $85921ba7e9a34dfd$var$initGalleryStripVideoFallback = ()=>{
    const videos = document.querySelectorAll('[data-gallery-strip-video]');
    videos.forEach((video)=>{
        const showFallbackImage = ()=>{
            const image = document.createElement('img');
            image.src = video.getAttribute('poster');
            image.alt = '';
            image.loading = 'lazy';
            video.replaceWith(image);
        };
        // By the time this runs the browser has already parsed the <source>
        // and may have already rejected it (e.g. a `type` it doesn't support),
        // so check the persisted state first instead of only listening forward.
        if (video.error || video.networkState === video.NETWORK_NO_SOURCE) {
            showFallbackImage();
            return;
        }
        video.addEventListener('error', showFallbackImage, {
            once: true
        });
    });
};
var $85921ba7e9a34dfd$export$2e2bcd8739ae039 = $85921ba7e9a34dfd$var$initGalleryStripVideoFallback;


/**
 * Swaps a shared image when a FAQ accordion item opens (see the extended
 * FAQ section on woocommerce/single-product.php). Mutual exclusivity
 * ("opening one closes the others") is native <details name="..."> behaviour
 * and needs no JS - this only handles the image swap on top of that.
 *
 * The swap is cross-faded: the image fades out, the src changes once it's
 * invisible, then it fades back in (see the opacity transition on
 * .product-faq-extended-media img in views/_product.scss).
 *
 * Scope with `data-faq-image-sync` on the wrapper, `data-faq-image-target`
 * on the <img>, and `data-faq-image` (the URL to swap to) on each <details>.
 */ const $7f9aca18ce5c2fd5$var$FADE_DURATION = 200;
const $7f9aca18ce5c2fd5$var$initFaqImageSync = ()=>{
    const sections = document.querySelectorAll('[data-faq-image-sync]');
    sections.forEach((section)=>{
        const image = section.querySelector('[data-faq-image-target]');
        const items = section.querySelectorAll('[data-faq-image]');
        if (!image) return;
        items.forEach((item)=>{
            item.addEventListener('toggle', ()=>{
                if (!item.open) return;
                const nextSrc = item.dataset.faqImage;
                if (!nextSrc || image.src === nextSrc) return;
                image.style.opacity = '0';
                window.setTimeout(()=>{
                    image.src = nextSrc;
                    image.style.opacity = '1';
                }, $7f9aca18ce5c2fd5$var$FADE_DURATION);
            });
        });
    });
};
var $7f9aca18ce5c2fd5$export$2e2bcd8739ae039 = $7f9aca18ce5c2fd5$var$initFaqImageSync;


/**
 * Animates open/close on the accordion (.accordion-item, a
 * native <details>/<summary>). Native details/summary jump open/closed
 * instantly with no way to transition `height: auto`, so this intercepts
 * the toggle, animates height with the Web Animations API, and cross-fades
 * the panel content at the same time.
 *
 * Exclusive groups (only one item open at a time, e.g. the extended FAQ)
 * are opted into via `data-accordion-group="some-name"` on each item,
 * grouped together below - NOT the native <details name="..."> attribute:
 * that closes other group members synchronously and instantly the moment
 * `.open` is set, before this module ever gets a chance to animate them,
 * which is exactly the abrupt jump this file exists to avoid.
 */ const $297e0f5ce4abb359$var$DURATION = 250;
const $297e0f5ce4abb359$var$EASING = 'ease-out';
class $297e0f5ce4abb359$var$AnimatedAccordion {
    constructor(details){
        this.details = details;
        this.summary = details.querySelector('summary');
        this.panel = details.querySelector('.accordion-panel');
        this.group = null; // assigned by initAccordion for grouped items
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        if (!this.summary || !this.panel) return;
        this.summary.addEventListener('click', (event)=>this.onClick(event));
    }
    onClick(event) {
        event.preventDefault();
        if (this.isClosing || !this.details.open) {
            this.group?.forEach((other)=>{
                if (other !== this && (other.details.open || other.isExpanding)) other.shrink();
            });
            this.open();
        } else if (this.isExpanding || this.details.open) this.shrink();
    }
    open() {
        this.details.style.height = `${this.details.offsetHeight}px`;
        this.details.open = true;
        window.requestAnimationFrame(()=>this.expand());
    }
    expand() {
        this.isExpanding = true;
        const startHeight = `${this.details.offsetHeight}px`;
        // Measure the true natural open height by momentarily lifting the
        // pinned height rather than summing summary.offsetHeight + panel.offsetHeight:
        // that sum silently drops the panel <p>'s default browser margin (and any
        // other spacing between the two), which is exactly what produced a visible
        // jump at the end of the animation once the real height turned out taller
        // than the animated target. Read-then-restore happens before the next
        // paint, so nothing flashes to full size.
        //
        // This has to happen BEFORE `overflow: hidden` is applied below: that
        // establishes a new block formatting context, which stops the panel's
        // margin from collapsing the way it normally does and would otherwise
        // inflate this exact measurement.
        this.details.style.height = 'auto';
        const endHeight = `${this.details.offsetHeight}px`;
        this.details.style.height = startHeight;
        this.details.style.overflow = 'hidden';
        this.panel.style.opacity = '0';
        if (this.animation) this.animation.cancel();
        this.animation = this.details.animate({
            height: [
                startHeight,
                endHeight
            ]
        }, {
            duration: $297e0f5ce4abb359$var$DURATION,
            easing: $297e0f5ce4abb359$var$EASING
        });
        this.animation.onfinish = ()=>this.onAnimationFinish(true);
        this.animation.oncancel = ()=>{
            this.isExpanding = false;
        };
        window.requestAnimationFrame(()=>{
            this.panel.style.opacity = '1';
        });
    }
    shrink() {
        this.isClosing = true;
        // Measured before `overflow: hidden` is applied below, same reasoning
        // as in expand(): it would otherwise inflate this reading too.
        const startHeight = `${this.details.offsetHeight}px`;
        // Closed state has no panel in flow, but the details element's own
        // border still counts toward its rendered height - add it so this lands
        // exactly on the natural closed size instead of a couple px short.
        const border = getComputedStyle(this.details);
        const borderHeight = parseFloat(border.borderTopWidth) + parseFloat(border.borderBottomWidth);
        const endHeight = `${this.summary.offsetHeight + borderHeight}px`;
        this.details.style.overflow = 'hidden';
        this.panel.style.opacity = '0';
        if (this.animation) this.animation.cancel();
        this.animation = this.details.animate({
            height: [
                startHeight,
                endHeight
            ]
        }, {
            duration: $297e0f5ce4abb359$var$DURATION,
            easing: $297e0f5ce4abb359$var$EASING
        });
        this.animation.onfinish = ()=>this.onAnimationFinish(false);
        this.animation.oncancel = ()=>{
            this.isClosing = false;
        };
    }
    onAnimationFinish(open) {
        this.details.open = open;
        this.animation = null;
        this.isClosing = false;
        this.isExpanding = false;
        this.details.style.height = '';
        this.details.style.overflow = '';
        this.panel.style.opacity = '';
    }
}
const $297e0f5ce4abb359$var$initAccordion = ()=>{
    const groups = new Map();
    document.querySelectorAll('.accordion-item').forEach((details)=>{
        const instance = new $297e0f5ce4abb359$var$AnimatedAccordion(details);
        const groupName = details.dataset.accordionGroup;
        if (!groupName) return;
        if (!groups.has(groupName)) groups.set(groupName, []);
        groups.get(groupName).push(instance);
    });
    groups.forEach((group)=>{
        group.forEach((instance)=>{
            instance.group = group;
        });
    });
};
var $297e0f5ce4abb359$export$2e2bcd8739ae039 = $297e0f5ce4abb359$var$initAccordion;


/**
 * Cart drawer (<dialog id="cart-drawer">, template-parts/cart/drawer.php).
 *
 * Opens from the header cart icon (template-parts/header/actions.php). The
 * quantity stepper and remove buttons hit the cart_drawer_update AJAX
 * action (inc/hooks/cart-drawer.php), which re-renders the whole drawer
 * content server-side from WC()->cart and sends it back - simplest way to
 * stay correct with stock limits, fees and the payment discount all at once.
 */ 
const $9498db5ef5a5bd70$var$updateDrawer = (content, count)=>{
    const contentEl = document.getElementById('cart-drawer-content');
    const countEl = document.getElementById('cart-drawer-count');
    const badgeEl = document.querySelector('.header-actions-cart-count');
    if (contentEl) contentEl.innerHTML = content;
    if (countEl) countEl.textContent = `(${count})`;
    if (badgeEl) {
        badgeEl.textContent = count;
        badgeEl.classList.toggle('is-empty', count === 0);
    }
};
const $9498db5ef5a5bd70$var$requestCartUpdate = async (cartItemKey, cartAction)=>{
    const cartDrawerData = window.air_light_cartDrawer;
    if (!cartDrawerData) return;
    const body = new FormData();
    body.append('action', 'cart_drawer_update');
    body.append('nonce', cartDrawerData.nonce);
    body.append('cart_item_key', cartItemKey);
    body.append('cart_action', cartAction);
    const response = await fetch(cartDrawerData.ajax_url, {
        method: 'POST',
        body: body
    });
    const { success: success, data: data } = await response.json();
    if (success) $9498db5ef5a5bd70$var$updateDrawer(data.content, data.count);
};
const $9498db5ef5a5bd70$var$initCartDrawer = ()=>{
    const dialog = document.getElementById('cart-drawer');
    if (!dialog || typeof dialog.showModal !== 'function') return;
    document.querySelectorAll('[data-cart-open]').forEach((trigger)=>{
        trigger.addEventListener('click', ()=>dialog.showModal());
    });
    // WooCommerce's core add-to-cart.js (jQuery, always loaded alongside any
    // .ajax_add_to_cart button) fires this on document.body once its own AJAX
    // request succeeds and has already swapped in the fresh drawer content via
    // the woocommerce_add_to_cart_fragments filter (inc/hooks/cart-drawer.php).
    // Besides opening the dialog, this turns the button itself into its
    // "added" state (data-added-label/data-added-aria-label/data-added-href,
    // set in woocommerce/content-product.php and woocommerce/single-product.php)
    // rather than leaving WooCommerce's own "Ver carrito" text it inserts right
    // after the button (sass hides that one - a second, separate link next to
    // the button would be redundant). Adding .wc-interactive opts the button
    // out of add-to-cart.js's own delegated click handler
    // (`.add_to_cart_button:not(.wc-interactive)`), so the click listener below
    // can take over for anything after this point.
    if (window.jQuery) window.jQuery(document.body).on('added_to_cart', (event, fragments, cartHash, $button)=>{
        if (!dialog.open) dialog.showModal();
        const button = $button && $button[0];
        if (!button || !button.dataset.addedLabel) return;
        const label = button.querySelector('[data-action-label]');
        if (label) label.textContent = button.dataset.addedLabel;
        if (button.dataset.addedAriaLabel) button.setAttribute('aria-label', button.dataset.addedAriaLabel);
        if (button.dataset.addedHref) button.href = button.dataset.addedHref;
        button.classList.add('wc-interactive');
    });
    // Once a button has flipped to its "added" state (above), clicking it
    // again should just reopen the drawer (card-product's "Ver
    // carrito") - unless it carries data-added-href (single-product.php's
    // "Finalizar compra"), in which case it should navigate to checkout via
    // its own href instead of being intercepted.
    document.body.addEventListener('click', (event)=>{
        const button = event.target.closest('.wc-interactive[data-added-label]');
        if (!button || button.dataset.addedHref) return;
        event.preventDefault();
        dialog.showModal();
    });
    // Click on the ::backdrop (the dialog element itself receives the click
    // when it lands outside the content box) dismisses it, same as
    // checkout-summary.
    dialog.addEventListener('click', (event)=>{
        if (event.target === dialog) dialog.close();
    });
    // Delegated - the close button, stepper and remove buttons are all
    // replaced wholesale whenever the drawer content re-renders.
    dialog.addEventListener('click', (event)=>{
        if (event.target.closest('[data-cart-close]')) {
            dialog.close();
            return;
        }
        const qtyButton = event.target.closest('[data-cart-qty]');
        const item = qtyButton?.closest('[data-cart-item-key]');
        if (!qtyButton || !item) return;
        (0, $f34086fc9474d956$export$f284d97446e8b58d)(qtyButton, ()=>$9498db5ef5a5bd70$var$requestCartUpdate(item.dataset.cartItemKey, qtyButton.dataset.cartQty));
    });
};
var $9498db5ef5a5bd70$export$2e2bcd8739ae039 = $9498db5ef5a5bd70$var$initCartDrawer;


/**
 * Iframe modal (<dialog id="iframe-modal">, template-parts/modal/iframe-modal.php).
 *
 * Any link with data-iframe-modal opens its href inside the modal's
 * iframe instead of navigating away - e.g. the checkout footer's Soporte /
 * Política de devoluciones / Envíos links (footer.php).
 */ const $a8da06564269d922$var$initIframeModal = ()=>{
    const dialog = document.getElementById('iframe-modal');
    const frame = document.getElementById('iframe-modal-frame');
    const title = document.getElementById('iframe-modal-title');
    if (!dialog || !frame || typeof dialog.showModal !== 'function') return;
    document.querySelectorAll('[data-iframe-modal]').forEach((trigger)=>{
        trigger.addEventListener('click', (event)=>{
            event.preventDefault();
            const label = trigger.textContent.trim();
            frame.src = trigger.href;
            frame.title = label;
            title.textContent = label;
            dialog.showModal();
        });
    });
    // Click on the ::backdrop (the dialog element itself receives the click
    // when it lands outside the content box) dismisses it, same as cart-drawer.
    dialog.addEventListener('click', (event)=>{
        if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('click', (event)=>{
        if (event.target.closest('[data-iframe-close]')) dialog.close();
    });
    // Fires on Escape and both dialog.close() paths above - stop the iframe's
    // content (and any media/audio in it) rather than leaving it loaded in
    // the background.
    dialog.addEventListener('close', ()=>{
        frame.src = 'about:blank';
    });
};
var $a8da06564269d922$export$2e2bcd8739ae039 = $a8da06564269d922$var$initIframeModal;


/**
 * "Página informativa" table of contents: highlights the link for whichever
 * numbered section is currently in view, so the sidebar always shows where
 * the reader is (see .informational-page-toc-link.is-active).
 */ const $131882cf5201d705$var$initPaginaInformativaToc = ()=>{
    const links = document.querySelectorAll('.informational-page-toc-link');
    if (!links.length) return;
    const sections = [
        ...links
    ].map((link)=>document.getElementById(link.getAttribute('href').slice(1))).filter(Boolean);
    const setActiveLink = (id)=>{
        links.forEach((link)=>{
            link.classList.toggle('is-active', link.getAttribute('href') === `#${id}`);
        });
    };
    // Highlight the first section by default, before the reader has scrolled
    // far enough for the observer below to report anything as intersecting.
    setActiveLink(sections[0]?.id);
    const observer = new IntersectionObserver((entries)=>{
        const visible = entries.find((entry)=>entry.isIntersecting);
        if (visible) setActiveLink(visible.target.id);
    }, {
        // Treat a section as "current" once it's crossed into the top third of
        // the viewport, so the highlight changes before the reader scrolls past it.
        rootMargin: '0px 0px -70% 0px'
    });
    sections.forEach((section)=>observer.observe(section));
};
var $131882cf5201d705$export$2e2bcd8739ae039 = $131882cf5201d705$var$initPaginaInformativaToc;


/**
 * Shop filter bar (woocommerce/archive-product.php, sass/views/_shop.scss).
 * Each attribute dropdown holds checkboxes plus one hidden input per
 * taxonomy - WooCommerce's native filter_{attribute} query var only reads a
 * single comma-separated string, never an array, so on submit this joins
 * whichever checkboxes are checked into that hidden input. Also closes any
 * other open dropdown when one opens, since they're independent <details>
 * elements with no built-in mutual exclusivity.
 */ const $0984041d0fd38094$var$initShopFilters = ()=>{
    const bar = document.querySelector('[data-shop-filter-bar]');
    if (!bar) return;
    const dropdowns = bar.querySelectorAll('[data-shop-filter]');
    dropdowns.forEach((dropdown)=>{
        dropdown.addEventListener('toggle', ()=>{
            if (!dropdown.open) return;
            dropdowns.forEach((other)=>{
                if (other !== dropdown) other.open = false;
            });
        });
    });
    bar.addEventListener('submit', ()=>{
        const hiddenInputs = bar.querySelectorAll('[data-filter-hidden]');
        hiddenInputs.forEach((hidden)=>{
            const { filterHidden: taxonomy } = hidden.dataset;
            const checked = bar.querySelectorAll(`[data-filter-taxonomy="${taxonomy}"]:checked`);
            hidden.value = Array.from(checked).map((checkbox)=>checkbox.value).join(',');
        });
    });
};
var $0984041d0fd38094$export$2e2bcd8739ae039 = $0984041d0fd38094$var$initShopFilters;


/**
 * Cycles the messages inside the animated bubble above the floating
 * WhatsApp button (see .whatsapp-float-bubble in footer.php), one at a
 * time: fade/slide in, hold, fade/slide out, wait, repeat. Messages
 * themselves come from Ajustes > WhatsApp (inc/acf-fields/ajustes-whatsapp.php).
 * No-ops entirely under prefers-reduced-motion, since the bubble is a
 * decorative nudge rather than essential content.
 */ const $581635f34d490187$var$FIRST_DELAY = 4000;
const $581635f34d490187$var$SHOW_DURATION = 6000;
const $581635f34d490187$var$HIDE_DURATION = 10000;
const $581635f34d490187$var$initWhatsappFloatBubble = ()=>{
    const bubble = document.querySelector('[data-whatsapp-float-bubble]');
    if (!bubble || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const messages = [
        ...bubble.querySelectorAll('.whatsapp-float-bubble-message')
    ];
    if (!messages.length) return;
    let index = 0;
    const showNext = ()=>{
        messages.forEach((message, messageIndex)=>{
            message.classList.toggle('is-current', messageIndex === index);
        });
        bubble.classList.add('is-visible');
        setTimeout(()=>{
            bubble.classList.remove('is-visible');
            index = (index + 1) % messages.length;
            setTimeout(showNext, $581635f34d490187$var$HIDE_DURATION);
        }, $581635f34d490187$var$SHOW_DURATION);
    };
    setTimeout(showNext, $581635f34d490187$var$FIRST_DELAY);
};
var $581635f34d490187$export$2e2bcd8739ae039 = $581635f34d490187$var$initWhatsappFloatBubble;


/**
 * Thank-you page "Descargar PDF"/"Compartir" buttons (template-parts/order/success.php).
 * No server-side PDF generation: "download" just triggers the browser's own
 * print dialog (window.print(), styled by @media print rules in
 * _thank-you.scss) so the visitor picks "Save as PDF" themselves.
 * "Share" uses the Web Share API where available, falling back to copying
 * the page URL to the clipboard - the button hides itself entirely if
 * neither is supported.
 */ const $62535b819631fb62$var$initThankYou = ()=>{
    const downloadButton = document.querySelector('[data-thank-you-download-pdf]');
    if (downloadButton) downloadButton.addEventListener('click', ()=>{
        window.print();
    });
    const shareButton = document.querySelector('[data-thank-you-share]');
    if (!shareButton) return;
    const canShare = typeof navigator.share === 'function';
    const canCopy = navigator.clipboard && typeof navigator.clipboard.writeText === 'function';
    if (!canShare && !canCopy) {
        shareButton.remove();
        return;
    }
    const shareLabel = shareButton.querySelector('[data-thank-you-share-label]');
    const defaultLabel = shareLabel ? shareLabel.textContent : '';
    shareButton.addEventListener('click', async ()=>{
        const shareData = {
            title: shareButton.dataset.shareTitle || document.title,
            text: shareButton.dataset.shareText || '',
            url: window.location.href
        };
        if (canShare) {
            try {
                await navigator.share(shareData);
            } catch  {
            // Ignore: user cancelled the native share sheet, nothing to recover.
            }
            return;
        }
        await navigator.clipboard.writeText(shareData.url);
        if (shareLabel) {
            shareLabel.textContent = shareButton.dataset.shareCopiedLabel || defaultLabel;
            setTimeout(()=>{
                shareLabel.textContent = defaultLabel;
            }, 2000);
        }
    });
};
var $62535b819631fb62$export$2e2bcd8739ae039 = $62535b819631fb62$var$initThankYou;


/**
 * Site-wide cookie notice (.cookie-notice, footer.php's render_cookie_notice()).
 * Starts `hidden` in the server-rendered markup - shown here only if the
 * visitor hasn't already accepted, checked via document.cookie rather than
 * server-side so this stays correct under page caching (see
 * inc/hooks/cookie-notice.php's own docblock for why). Accepting sets a
 * 1-year cookie and hides the bar; nothing else on the page reacts to it.
 */ const $d79072aae44c7199$var$COOKIE_NAME = 'cookie_consent';
const $d79072aae44c7199$var$COOKIE_MAX_AGE_DAYS = 365;
const $d79072aae44c7199$var$hasAcceptedCookies = ()=>document.cookie.split(';').some((cookie)=>cookie.trim().startsWith(`${$d79072aae44c7199$var$COOKIE_NAME}=`));
const $d79072aae44c7199$var$acceptCookies = ()=>{
    const maxAge = $d79072aae44c7199$var$COOKIE_MAX_AGE_DAYS * 86400;
    document.cookie = `${$d79072aae44c7199$var$COOKIE_NAME}=1; max-age=${maxAge}; path=/; SameSite=Lax`;
};
const $d79072aae44c7199$var$initCookieNotice = ()=>{
    const notice = document.querySelector('[data-cookie-notice]');
    const acceptButton = document.querySelector('[data-cookie-notice-accept]');
    if (!notice || !acceptButton || $d79072aae44c7199$var$hasAcceptedCookies()) return;
    notice.hidden = false;
    acceptButton.addEventListener('click', ()=>{
        $d79072aae44c7199$var$acceptCookies();
        notice.hidden = true;
    });
};
var $d79072aae44c7199$export$2e2bcd8739ae039 = $d79072aae44c7199$var$initCookieNotice;


/**
 * Testimonials carousel.
 */ const $45dca872f7e6207e$var$initTestimonials = ()=>{
    document.querySelectorAll('[data-testimonials]').forEach((root)=>{
        const section = root.closest('.home-testimonials') || root.parentElement;
        const prev = section?.querySelector('[data-testimonials-prev]');
        const next = section?.querySelector('[data-testimonials-next]');
        const item = root.querySelector('.home-testimonial');
        if (!item) return;
        const amount = ()=>{
            const list = root.querySelector('.home-testimonials-list');
            const gap = list ? parseFloat(getComputedStyle(list).gap) || 24 : 24;
            return item.getBoundingClientRect().width + gap;
        };
        const syncNav = ()=>{
            const max = Math.max(0, root.scrollWidth - root.clientWidth);
            const left = root.scrollLeft;
            const atStart = left <= 2;
            const atEnd = left >= max - 2 || max <= 0;
            if (prev) {
                prev.disabled = atStart;
                prev.classList.toggle('is-disabled', atStart);
                prev.setAttribute('aria-disabled', atStart ? 'true' : 'false');
            }
            if (next) {
                next.disabled = atEnd;
                next.classList.toggle('is-disabled', atEnd);
                next.setAttribute('aria-disabled', atEnd ? 'true' : 'false');
            }
        };
        prev?.addEventListener('click', ()=>{
            root.scrollBy({
                left: -amount(),
                behavior: 'smooth'
            });
        });
        next?.addEventListener('click', ()=>{
            root.scrollBy({
                left: amount(),
                behavior: 'smooth'
            });
        });
        root.addEventListener('scroll', syncNav, {
            passive: true
        });
        window.addEventListener('resize', syncNav);
        syncNav();
    });
};
var $45dca872f7e6207e$export$2e2bcd8739ae039 = $45dca872f7e6207e$var$initTestimonials;


/**
 * Servicio PDP gallery carousel + lightbox (with touch swipe).
 */ const $80d4d6c8dc24e8c7$var$initServicioGallery = ()=>{
    const root = document.querySelector('[data-spd-gallery]');
    if (!root) return;
    const track = root.querySelector('[data-spd-gallery-track]');
    const viewport = root.querySelector('[data-spd-gallery-viewport]');
    const slides = [
        ...root.querySelectorAll('.spd-gallery-slide')
    ];
    const prevBtn = root.querySelector('[data-spd-gallery-prev]');
    const nextBtn = root.querySelector('[data-spd-gallery-next]');
    const openBtns = [
        ...root.querySelectorAll('[data-spd-gallery-open]')
    ];
    const lightbox = root.querySelector('[data-spd-lightbox]');
    const lbImg = root.querySelector('[data-spd-lightbox-img]');
    const lbCounter = root.querySelector('[data-spd-lightbox-counter]');
    const lbPrev = root.querySelector('[data-spd-lightbox-prev]');
    const lbNext = root.querySelector('[data-spd-lightbox-next]');
    const lbCloseBtns = [
        ...root.querySelectorAll('[data-spd-lightbox-close]')
    ];
    if (!track || !slides.length) return;
    // Gallery track uses transform; fixed children would anchor to that box.
    // Portal the lightbox to <body> so it always covers the full viewport.
    if (lightbox && lightbox.parentElement !== document.body) document.body.appendChild(lightbox);
    let index = 0;
    let lbIndex = 0;
    const gap = ()=>{
        const style = getComputedStyle(track);
        return parseFloat(style.columnGap || style.gap) || 16;
    };
    const visibleCount = ()=>{
        if (window.matchMedia('(max-width: 767px)').matches) return 1;
        if (window.matchMedia('(max-width: 899px)').matches) return 2;
        return 3;
    };
    const maxIndex = ()=>Math.max(0, slides.length - visibleCount());
    const updateNav = ()=>{
        const max = maxIndex();
        if (prevBtn) {
            prevBtn.disabled = index <= 0;
            prevBtn.hidden = slides.length <= 3;
        }
        if (nextBtn) {
            nextBtn.disabled = index >= max;
            nextBtn.hidden = slides.length <= 3;
        }
    };
    const goTo = (next)=>{
        index = Math.min(Math.max(0, next), maxIndex());
        const slide = slides[0];
        const step = slide.getBoundingClientRect().width + gap();
        track.style.transform = `translate3d(-${index * step}px, 0, 0)`;
        updateNav();
    };
    prevBtn?.addEventListener('click', ()=>goTo(index - 1));
    nextBtn?.addEventListener('click', ()=>goTo(index + 1));
    window.addEventListener('resize', ()=>goTo(index));
    const bindSwipe = (el, onLeft, onRight)=>{
        if (!el) return;
        let startX = 0;
        let startY = 0;
        let tracking = false;
        el.addEventListener('touchstart', (e)=>{
            if (!e.touches || e.touches.length !== 1) return;
            tracking = true;
            startX = e.touches[0].clientX;
            startY = e.touches[0].clientY;
        }, {
            passive: true
        });
        el.addEventListener('touchend', (e)=>{
            if (!tracking || !e.changedTouches || !e.changedTouches.length) return;
            tracking = false;
            const dx = e.changedTouches[0].clientX - startX;
            const dy = e.changedTouches[0].clientY - startY;
            if (Math.abs(dx) < 40 || Math.abs(dx) < Math.abs(dy)) return;
            if (dx < 0) onLeft();
            else onRight();
        }, {
            passive: true
        });
    };
    bindSwipe(viewport || track, ()=>goTo(index + 1), ()=>goTo(index - 1));
    const sources = openBtns.map((btn)=>({
            full: btn.getAttribute('data-full') || btn.querySelector('img')?.src || '',
            alt: btn.querySelector('img')?.alt || ''
        }));
    const syncLightbox = ()=>{
        if (!lbImg || !sources[lbIndex]) return;
        lbImg.src = sources[lbIndex].full;
        lbImg.alt = sources[lbIndex].alt;
        if (lbCounter) {
            lbCounter.hidden = sources.length < 2;
            lbCounter.textContent = `${lbIndex + 1} / ${sources.length}`;
        }
        if (lbPrev) lbPrev.hidden = sources.length < 2;
        if (lbNext) lbNext.hidden = sources.length < 2;
    };
    const openLightbox = (i)=>{
        if (!lightbox) return;
        lbIndex = i;
        syncLightbox();
        lightbox.hidden = false;
        document.documentElement.classList.add('spd-lightbox-open');
        lightbox.querySelector('.spd-lightbox-close')?.focus();
    };
    const closeLightbox = ()=>{
        if (!lightbox) return;
        lightbox.hidden = true;
        document.documentElement.classList.remove('spd-lightbox-open');
    };
    openBtns.forEach((btn)=>{
        btn.addEventListener('click', ()=>{
            const i = parseInt(btn.getAttribute('data-index') || '0', 10);
            openLightbox(Number.isNaN(i) ? 0 : i);
        });
    });
    lbCloseBtns.forEach((btn)=>btn.addEventListener('click', closeLightbox));
    lbPrev?.addEventListener('click', ()=>{
        lbIndex = (lbIndex - 1 + sources.length) % sources.length;
        syncLightbox();
    });
    lbNext?.addEventListener('click', ()=>{
        lbIndex = (lbIndex + 1) % sources.length;
        syncLightbox();
    });
    bindSwipe(lightbox?.querySelector('.spd-lightbox-dialog') || lightbox, ()=>{
        if (!lightbox || lightbox.hidden || sources.length < 2) return;
        lbIndex = (lbIndex + 1) % sources.length;
        syncLightbox();
    }, ()=>{
        if (!lightbox || lightbox.hidden || sources.length < 2) return;
        lbIndex = (lbIndex - 1 + sources.length) % sources.length;
        syncLightbox();
    });
    document.addEventListener('keydown', (e)=>{
        if (!lightbox || lightbox.hidden) return;
        if (e.key === 'Escape') closeLightbox();
        if (e.key === 'ArrowLeft') {
            lbIndex = (lbIndex - 1 + sources.length) % sources.length;
            syncLightbox();
        }
        if (e.key === 'ArrowRight') {
            lbIndex = (lbIndex + 1) % sources.length;
            syncLightbox();
        }
    });
    updateNav();
    goTo(0);
};
var $80d4d6c8dc24e8c7$export$2e2bcd8739ae039 = $80d4d6c8dc24e8c7$var$initServicioGallery;


/**
 * Subtle scroll reveals for M&M section blocks.
 * Respects prefers-reduced-motion; heroes fade in on load only.
 */ const $57500460482a3b27$var$HERO_SECTION = /(?:^|\s)(?:home|ns|sv|sg|spd|ct)-hero(?:\s|$)/;
const $57500460482a3b27$var$HERO_INNER = [
    '.home-hero-content',
    '.ns-hero-inner',
    '.sv-intro-inner',
    '.sg-intro-inner',
    '.spd-hero-inner',
    '.ct-form-inner'
].join(', ');
const $57500460482a3b27$var$STAGGER_GRIDS = [
    '.home-cards-grid',
    '.sv-method-steps',
    '.sg-process-grid',
    '.spd-others-grid',
    '.ns-quality-grid'
].join(', ');
function $57500460482a3b27$var$prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}
function $57500460482a3b27$var$revealNow(el) {
    el.classList.add('is-visible');
}
function $57500460482a3b27$var$observeReveal(el) {
    if (!('IntersectionObserver' in window)) {
        $57500460482a3b27$var$revealNow(el);
        return;
    }
    const observer = new IntersectionObserver((entries)=>{
        entries.forEach((entry)=>{
            if (!entry.isIntersecting) return;
            $57500460482a3b27$var$revealNow(entry.target);
            observer.unobserve(entry.target);
        });
    }, {
        root: null,
        rootMargin: '0px 0px -8% 0px',
        threshold: 0.12
    });
    observer.observe(el);
}
function $57500460482a3b27$var$initHeroes() {
    document.querySelectorAll('.site-main section').forEach((section)=>{
        if (!$57500460482a3b27$var$HERO_SECTION.test(section.className)) return;
        const inner = section.querySelector($57500460482a3b27$var$HERO_INNER) || section.querySelector('.wrap');
        if (!inner) return;
        inner.classList.add('mym-reveal', 'mym-reveal--hero');
        window.requestAnimationFrame(()=>{
            window.setTimeout(()=>$57500460482a3b27$var$revealNow(inner), 80);
        });
    });
}
function $57500460482a3b27$var$initSections() {
    document.querySelectorAll('.site-main section').forEach((section)=>{
        if (section.parentElement?.closest('section')) return;
        if ($57500460482a3b27$var$HERO_SECTION.test(section.className)) return;
        if (section.querySelector($57500460482a3b27$var$STAGGER_GRIDS)) return;
        section.classList.add('mym-reveal');
        $57500460482a3b27$var$observeReveal(section);
    });
}
function $57500460482a3b27$var$initStaggerGrids() {
    document.querySelectorAll($57500460482a3b27$var$STAGGER_GRIDS).forEach((grid)=>{
        const items = [
            ...grid.children
        ];
        if (items.length < 2) return;
        items.forEach((item, index)=>{
            item.classList.add('mym-reveal', 'mym-reveal--scale');
            item.style.setProperty('--mym-reveal-delay', `${index * 70}ms`);
            $57500460482a3b27$var$observeReveal(item);
        });
    });
}
function $57500460482a3b27$export$2e2bcd8739ae039() {
    if ($57500460482a3b27$var$prefersReducedMotion()) return;
    $57500460482a3b27$var$initHeroes();
    $57500460482a3b27$var$initSections();
    $57500460482a3b27$var$initStaggerGrids();
}


// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');
document.addEventListener('DOMContentLoaded', ()=>{
    (0, $b4666473b658c810$export$2e2bcd8739ae039)();
    (0, $8bc14fcfe2c466c1$export$2e2bcd8739ae039)();
    (0, $be72fc40c39eb295$export$554fdaa2aa89d7a4)();
    (0, $be72fc40c39eb295$export$636763119f974537)();
    (0, $244ddd85eab3a286$export$2e2bcd8739ae039)();
    (0, $4e71423afcfa2c83$export$2e2bcd8739ae039)();
    // Init navigation
    // If you want to enable click based navigation, comment navDesktop() and uncomment navClick()
    // Remember to enable styles in assets/src/sass/navigation/navigation.scss
    (0, $d2563fe93513be8c$export$9c43844ef57ea1d0)();
    // navClick();
    (0, $d2563fe93513be8c$export$3a2707b50c3b4a73)();
    (0, $950a97cef1f72e57$export$2e2bcd8739ae039)();
    (0, $c6fe2c653adac37e$export$2e2bcd8739ae039)();
    (0, $5035070f670af9f6$export$2e2bcd8739ae039)();
    (0, $a8adb9e6b495cb5d$export$2e2bcd8739ae039)();
    (0, $85921ba7e9a34dfd$export$2e2bcd8739ae039)();
    (0, $7f9aca18ce5c2fd5$export$2e2bcd8739ae039)();
    (0, $297e0f5ce4abb359$export$2e2bcd8739ae039)();
    (0, $9498db5ef5a5bd70$export$2e2bcd8739ae039)();
    (0, $a8da06564269d922$export$2e2bcd8739ae039)();
    (0, $131882cf5201d705$export$2e2bcd8739ae039)();
    (0, $0984041d0fd38094$export$2e2bcd8739ae039)();
    (0, $581635f34d490187$export$2e2bcd8739ae039)();
    (0, $62535b819631fb62$export$2e2bcd8739ae039)();
    (0, $d79072aae44c7199$export$2e2bcd8739ae039)();
    (0, $45dca872f7e6207e$export$2e2bcd8739ae039)();
    (0, $80d4d6c8dc24e8c7$export$2e2bcd8739ae039)();
    (0, $57500460482a3b27$export$2e2bcd8739ae039)();
// Uncomment if you like to use a sticky navigation
// navSticky();
});

})();
//# sourceMappingURL=front-end.js.map
